// modules are defined as an array
// [ module function, map of requires ]
//
// map of requires is short require name -> numeric require
//
// anything defined in a previous bundle is accessed via the
// orig method which is the require for previous bundles

(function (modules, entry, mainEntry, parcelRequireName, globalName) {
  /* eslint-disable no-undef */
  var globalObject =
    typeof globalThis !== 'undefined'
      ? globalThis
      : typeof self !== 'undefined'
      ? self
      : typeof window !== 'undefined'
      ? window
      : typeof global !== 'undefined'
      ? global
      : {};
  /* eslint-enable no-undef */

  // Save the require from previous bundle to this closure if any
  var previousRequire =
    typeof globalObject[parcelRequireName] === 'function' &&
    globalObject[parcelRequireName];

  var cache = previousRequire.cache || {};
  // Do not use `require` to prevent Webpack from trying to bundle this call
  var nodeRequire =
    typeof module !== 'undefined' &&
    typeof module.require === 'function' &&
    module.require.bind(module);

  function newRequire(name, jumped) {
    if (!cache[name]) {
      if (!modules[name]) {
        // if we cannot find the module within our internal map or
        // cache jump to the current global require ie. the last bundle
        // that was added to the page.
        var currentRequire =
          typeof globalObject[parcelRequireName] === 'function' &&
          globalObject[parcelRequireName];
        if (!jumped && currentRequire) {
          return currentRequire(name, true);
        }

        // If there are other bundles on this page the require from the
        // previous one is saved to 'previousRequire'. Repeat this as
        // many times as there are bundles until the module is found or
        // we exhaust the require chain.
        if (previousRequire) {
          return previousRequire(name, true);
        }

        // Try the node require function if it exists.
        if (nodeRequire && typeof name === 'string') {
          return nodeRequire(name);
        }

        var err = new Error("Cannot find module '" + name + "'");
        err.code = 'MODULE_NOT_FOUND';
        throw err;
      }

      localRequire.resolve = resolve;
      localRequire.cache = {};

      var module = (cache[name] = new newRequire.Module(name));

      modules[name][0].call(
        module.exports,
        localRequire,
        module,
        module.exports,
        this
      );
    }

    return cache[name].exports;

    function localRequire(x) {
      var res = localRequire.resolve(x);
      return res === false ? {} : newRequire(res);
    }

    function resolve(x) {
      var id = modules[name][1][x];
      return id != null ? id : x;
    }
  }

  function Module(moduleName) {
    this.id = moduleName;
    this.bundle = newRequire;
    this.exports = {};
  }

  newRequire.isParcelRequire = true;
  newRequire.Module = Module;
  newRequire.modules = modules;
  newRequire.cache = cache;
  newRequire.parent = previousRequire;
  newRequire.register = function (id, exports) {
    modules[id] = [
      function (require, module) {
        module.exports = exports;
      },
      {},
    ];
  };

  Object.defineProperty(newRequire, 'root', {
    get: function () {
      return globalObject[parcelRequireName];
    },
  });

  globalObject[parcelRequireName] = newRequire;

  for (var i = 0; i < entry.length; i++) {
    newRequire(entry[i]);
  }

  if (mainEntry) {
    // Expose entry point to Node, AMD or browser globals
    // Based on https://github.com/ForbesLindesay/umd/blob/master/template.js
    var mainExports = newRequire(mainEntry);

    // CommonJS
    if (typeof exports === 'object' && typeof module !== 'undefined') {
      module.exports = mainExports;

      // RequireJS
    } else if (typeof define === 'function' && define.amd) {
      define(function () {
        return mainExports;
      });

      // <script>
    } else if (globalName) {
      this[globalName] = mainExports;
    }
  }
})({"i56Ye":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
var _index = require("./pages/index");
var _index1 = require("./global/index");
var _indexDefault = parcelHelpers.interopDefault(_index1);
const main = ()=>{
    (0, _index.initScriptPage)();
    (0, _indexDefault.default)();
};
window.onload = ()=>{
    main();
};

},{"./pages/index":"3bud7","./global/index":"5W8o4","@parcel/transformer-js/src/esmodule-helpers.js":"81AKE"}],"3bud7":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "VIEWS", ()=>VIEWS);
parcelHelpers.export(exports, "initScriptPage", ()=>initScriptPage);
var _index = require("./home/index");
var _indexDefault = parcelHelpers.interopDefault(_index);
var _success = require("./payment/success");
var _successDefault = parcelHelpers.interopDefault(_success);
var _index1 = require("./term/index");
var _indexDefault1 = parcelHelpers.interopDefault(_index1);
const VIEWS = [
    (0, _indexDefault.default),
    (0, _successDefault.default),
    (0, _indexDefault1.default)
];
const initScriptPage = ()=>{
    const dataNamespace = $("[data-barba-namespace]").attr("data-barba-namespace");
    VIEWS.forEach((page)=>{
        if (dataNamespace == page.namespace) page.afterEnter();
    });
};

},{"./home/index":"hhHrT","./payment/success":"7XlT4","./term/index":"d5rvS","@parcel/transformer-js/src/esmodule-helpers.js":"81AKE"}],"hhHrT":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _index = require("../../helper/index");
var _viewport = require("../../helper/viewport");
var _lenis = require("../../global/lenis");
var _planDataJson = require("../../../../plan-data.json");
var _planDataJsonDefault = parcelHelpers.interopDefault(_planDataJson);
var _splitText = require("../../libs/SplitText");
const home = {
    namespace: "home",
    afterEnter (data) {
        console.log(`enter ${this.namespace}`);
        let cont = $("body");
        function headerAnim() {
            let headTxt = new (0, _splitText.SplitText)(".home-hero-title", (0, _index.typeOpts).words);
            let scheduleTxt = new (0, _splitText.SplitText)(".header-main-schedule", (0, _index.typeOpts).chars);
            let tlSplitHead = gsap.timeline({
                onComplete: ()=>{
                    headTxt.revert();
                    scheduleTxt.revert();
                }
            });
            tlSplitHead.from(".home-hero-logo", {
                yPercent: 60,
                autoAlpha: 0,
                duration: 1,
                ease: "power2.out"
            }, 0).from(headTxt.words, {
                yPercent: 60,
                autoAlpha: 0,
                stagger: .03,
                duration: .6,
                ease: "power2.out"
            }, "<=.2");
            if ($(window).width() > 767) tlSplitHead.from(".home-hero-btn", {
                yPercent: 60,
                autoAlpha: 0,
                duration: .6,
                ease: "power2.out"
            }, "<=.4").from(".home-hero-discover", {
                autoAlpha: 0,
                duration: .6,
                ease: "power2.out"
            }, "<=.2").from(scheduleTxt.chars, {
                yPercent: 60,
                autoAlpha: 0,
                stagger: .01,
                duration: .8,
                ease: "power2.out"
            }, "<=0");
            tlSplitHead.from(".header-main-inner", {
                autoAlpha: 0,
                duration: .6,
                ease: "power2.out"
            }, "<=.2");
        }
        headerAnim();
        function heroParallax() {
            let tl = gsap.timeline({
                scrollTrigger: {
                    trigger: cont.find(".home-hero"),
                    start: "top top",
                    end: "bottom top",
                    scrub: .3
                }
            });
            tl.to(cont.find(".home-hero-bg img"), {
                y: "19rem",
                ease: "none"
            });
        }
        heroParallax();
        /** (💡)  - BENEFIT */ function homeBenefit() {
            function stackScroll() {
                const BENEFIT = {
                    stage: $(".home-benefit"),
                    wrap: $(".home-benefit--wrap"),
                    list: $(".home-benefit-list"),
                    item: $(".home-benefit-item"),
                    mainItem: $(".home-benefit-main"),
                    otherItem: $(".home-benefit-other"),
                    otherWrap: $(".home-benefit-other-wrap")
                };
                let mainItemSelect = (0, _index.selector)(BENEFIT.mainItem);
                let totalDistance = BENEFIT.mainItem.width() + BENEFIT.otherItem.width() * BENEFIT.otherItem.length;
                let otherWrapDistance = BENEFIT.mainItem.width() + (0, _viewport.cvUnit)(parseInt(BENEFIT.mainItem.css("padding-left"), 10), "rem") + (0, _viewport.cvUnit)((0, _viewport.viewportBreak)({
                    desktop: 15,
                    tablet: 5
                }), "rem");
                const ITEM_WIDTH = ($(".container").width() - (0, _viewport.percentage)(24.2, $(".container").width())) / (0, _viewport.viewportBreak)({
                    desktop: 5,
                    tablet: 2.7
                });
                gsap.set(BENEFIT.stage, {
                    height: totalDistance * 1.2 + (0, _viewport.cvUnit)(100, "rem")
                });
                let reqCheck;
                function checkHiddenImg() {
                    BENEFIT.otherItem.each((idx, item)=>{
                        if (idx + 1 < BENEFIT.otherItem.length) {
                            let rectCurrent = BENEFIT.otherItem.eq(idx).get(0).getBoundingClientRect();
                            let rectNext = BENEFIT.otherItem.eq(idx + 1).get(0).getBoundingClientRect();
                            let distanceItem = Math.abs(rectCurrent.left - rectNext.left);
                            let img = $(item).find(".home-benefit-other-img");
                            if (distanceItem <= ITEM_WIDTH) img.addClass("hidden");
                            else img.removeClass("hidden");
                        }
                    });
                    reqCheck = window.requestAnimationFrame(checkHiddenImg);
                }
                let scrollerTl = gsap.timeline({
                    defaults: {
                        ease: "none"
                    },
                    scrollTrigger: {
                        trigger: BENEFIT.stage,
                        start: `top-=${$("header").outerHeight()} top`,
                        end: "bottom bottom",
                        scrub: .6,
                        onEnter: ()=>checkHiddenImg(),
                        onEnterBack: ()=>checkHiddenImg(),
                        onLeaveBack: ()=>window.cancelAnimationFrame(reqCheck),
                        onLeave: ()=>window.cancelAnimationFrame(reqCheck)
                    }
                });
                scrollerTl.to(mainItemSelect("h2"), {
                    scale: 0.56,
                    transformOrigin: "top left",
                    ease: "linear",
                    duration: 1
                }, 0).to(mainItemSelect("p"), {
                    marginTop: -(0, _viewport.cvUnit)(6, "rem"),
                    duration: 1
                }, 0).to(BENEFIT.otherWrap, {
                    x: -otherWrapDistance,
                    duration: 1
                }, 0);
                BENEFIT.otherItem.each((index, item)=>{
                    let itemSelect = (0, _index.selector)(item);
                    gsap.set(itemSelect(".home-benefit-item-overlay"), {
                        scaleX: 0
                    });
                    let label = $(item).find(".home-benefit-other-title").text().toLowerCase().replace(" ", "-");
                    $(item).attr("data-label", `${label}`);
                    scrollerTl.add(`label${index}`).to(item, {
                        duration: 1
                    }).to(itemSelect("h3"), {
                        scale: (0, _viewport.viewportBreak)({
                            desktop: .75,
                            tablet: .5
                        }),
                        transformOrigin: "top left",
                        duration: 1
                    }, "<=0").to(itemSelect(".home-benefit-item-overlay"), {
                        scaleX: 1,
                        transformOrigin: "right",
                        duration: 1
                    }, "<=0").to(itemSelect("p"), {
                        autoAlpha: 0,
                        duration: 1
                    }, "<=0.2");
                    BENEFIT.otherItem.each((idx, el)=>{
                        if (idx > index) scrollerTl.to(el, {
                            x: -(ITEM_WIDTH * (1 + index)),
                            paddingLeft: (0, _viewport.viewportBreak)({
                                desktop: (0, _viewport.cvUnit)(40, "rem"),
                                tablet: (0, _viewport.cvUnit)(24, "rem")
                            }),
                            duration: 1
                        }, "<=0");
                    });
                });
                gsap.set(".home-showreel", {
                    marginTop: -(0, _viewport.cvUnit)((0, _viewport.viewportBreak)({
                        desktop: 60,
                        tablet: 85
                    }), "vh")
                });
                scrollerTl.to(BENEFIT.wrap, {
                    scale: (0, _viewport.viewportBreak)({
                        desktop: 0.5,
                        tablet: 0.8
                    }),
                    autoAlpha: 0,
                    duration: 2
                }, ">=-.8").to(BENEFIT.wrap, {
                    yPercent: -8,
                    duration: 1
                }, "<= .8");
                $(".home-benefit-other-sub-btn").on("click", function(e) {
                    e.preventDefault();
                    let target = $(this).closest(".home-benefit-item.home-benefit-other").index();
                    toLabel(1, scrollerTl, `label${target}`);
                });
                function toLabel(duration, timeline, label) {
                    (0, _lenis.lenis).stop();
                    const yStart = $(".home-benefit").offset().top - $(".header").outerHeight();
                    const now = timeline.progress();
                    timeline.seek(label);
                    const goToProgress = timeline.progress();
                    timeline.progress(now);
                    (0, _lenis.lenis).scrollTo(yStart + (timeline.scrollTrigger.end - timeline.scrollTrigger.start) * goToProgress, {
                        duration: duration,
                        force: true
                    });
                }
            }
            function animText() {
                let mainTitleTxt = new (0, _splitText.SplitText)(".home-benefit-main-title", (0, _index.typeOpts).words);
                let mainSubTxt = new (0, _splitText.SplitText)(".home-benefit-main-sub", (0, _index.typeOpts).words);
                let tlSplitHead = gsap.timeline({
                    scrollTrigger: {
                        trigger: ".home-benefit-list",
                        start: "top bottom-=10%"
                    },
                    onComplete: ()=>{
                        mainTitleTxt.revert();
                        mainSubTxt.revert();
                    }
                });
                tlSplitHead.from(mainTitleTxt.words, {
                    yPercent: 60,
                    autoAlpha: 0,
                    stagger: .03,
                    duration: .6,
                    ease: "power2.out"
                }, 0).from(mainSubTxt.words, {
                    yPercent: 60,
                    autoAlpha: 0,
                    stagger: .03,
                    duration: .6,
                    ease: "power2.out"
                }, "<=.4");
                $(".home-benefit-other").each((idx, el)=>{
                    if (idx < 3) {
                        let otherTitleTxt = new (0, _splitText.SplitText)($(el).find(".home-benefit-other-title"), (0, _index.typeOpts).chars);
                        let otherSubTxt = new (0, _splitText.SplitText)($(el).find(".home-benefit-other-sub-txt"), (0, _index.typeOpts).words);
                        tlSplitHead.from(otherTitleTxt.chars, {
                            yPercent: 60,
                            autoAlpha: 0,
                            stagger: .01,
                            duration: .6,
                            ease: "power2.out",
                            onComplete: ()=>{
                                otherTitleTxt.revert();
                            }
                        }, 0).from(otherSubTxt.words, {
                            yPercent: 60,
                            autoAlpha: 0,
                            stagger: .03,
                            duration: .6,
                            ease: "power2.out",
                            onComplete: ()=>{
                                otherSubTxt.revert();
                            }
                        }, "<=.2");
                    }
                });
            }
            animText();
            if ($(window).width() > 767) stackScroll();
        }
        homeBenefit();
        /** (💡)  - SHOWREEL */ function homeShowreel() {
            function galleryZoom() {
                const GALLERY = {
                    wrap: $(".home-showreel"),
                    item: ({ wrap, item })=>GALLERY.otherWrap.eq(wrap).find(GALLERY.otherInner).eq(item),
                    mainWrap: $(".home-showreel-main--inner"),
                    mainInner: $(".home-showreel-item-main"),
                    otherWrap: $(".home-showreel-other--inner"),
                    otherInner: $(".home-showreel-item-other"),
                    thumbPlay: $(".home-showreel-play")
                };
                let showreelTl = gsap.timeline({
                    defaults: {
                        ease: "none"
                    },
                    scrollTrigger: {
                        trigger: GALLERY.wrap,
                        start: `top bottom`,
                        end: "bottom bottom",
                        scrub: .6
                    }
                });
                const getOtherItem = ({ wrap, item })=>GALLERY.otherWrap.eq(wrap).find(GALLERY.otherInner).eq(item);
                (0, _viewport.viewportBreak)({
                    tablet: ()=>{
                        gsap.set(GALLERY.mainWrap, {
                            "padding": 0
                        });
                    }
                });
                showreelTl.to(".home-showreel-item-overlay", {
                    autoAlpha: 0,
                    duration: .15
                }).from([
                    getOtherItem({
                        wrap: 0,
                        item: 2
                    }),
                    getOtherItem({
                        wrap: 1,
                        item: 2
                    })
                ], {
                    y: 80,
                    duration: .2
                }, "<=0").from([
                    getOtherItem({
                        wrap: 0,
                        item: 1
                    }),
                    getOtherItem({
                        wrap: 1,
                        item: 1
                    })
                ], {
                    y: 200,
                    duration: .2
                }, "<=0").from([
                    getOtherItem({
                        wrap: 0,
                        item: 0
                    }),
                    getOtherItem({
                        wrap: 1,
                        item: 0
                    })
                ], {
                    y: 320,
                    duration: .2
                }, "<=0").fromTo(GALLERY.mainWrap, {
                    "clipPath": `inset(14% 37.35% 14% 37.35% round ${(0, _viewport.cvUnit)(20, "rem")}px)`
                }, {
                    "clipPath": `inset(0% 0% 0% 0% round ${(0, _viewport.cvUnit)(20, "rem")}px)`,
                    duration: 1
                }, ">=-0.1").to(GALLERY.otherInner.find(".img"), {
                    scale: 1.6,
                    duration: 1
                }, "<=0").to(getOtherItem({
                    wrap: 0,
                    item: 2
                }), {
                    xPercent: -255,
                    duration: 1
                }, "<=0").to(getOtherItem({
                    wrap: 0,
                    item: 1
                }), {
                    xPercent: -460,
                    duration: 1
                }, "<=0").to(getOtherItem({
                    wrap: 0,
                    item: 0
                }), {
                    xPercent: -760,
                    duration: 1
                }, "<=0").to(getOtherItem({
                    wrap: 1,
                    item: 2
                }), {
                    xPercent: 255,
                    duration: 1
                }, "<=0").to(getOtherItem({
                    wrap: 1,
                    item: 1
                }), {
                    xPercent: 460,
                    duration: 1
                }, "<=0").to(getOtherItem({
                    wrap: 1,
                    item: 0
                }), {
                    xPercent: 760,
                    duration: 1
                }, "<=0").from(GALLERY.thumbPlay, {
                    autoAlpha: 0,
                    y: 0,
                    duration: .5
                }, ">=-1").from(".home-showreel-play-wrapper", {
                    autoAlpha: 0,
                    y: 0,
                    duration: .5
                }, "<=0").from(".home-showreel-play-ic", {
                    scale: 0.8,
                    duration: 1
                }, "<=0").from(".home-showreel-play-ic svg", {
                    scale: 1.4,
                    duration: 1
                }, "<=0").from(".home-showreel-play-first", {
                    x: -(0, _viewport.cvUnit)(200, "rem"),
                    duration: 1
                }, "<=0").from(".home-showreel-play-last", {
                    x: (0, _viewport.cvUnit)(200, "rem"),
                    duration: 1
                }, "<=0");
            }
            function playShowreel() {
                let DOM = {
                    stage: $(".home-showreel"),
                    vid_wrap: $(".home-showreel--wrap"),
                    link_vid: $(".home-showreel-thumb-link"),
                    thumbnail: $(".home-showreel-thumb img"),
                    play: $(".home-showreel-play"),
                    video: $(".home-showreel-thumb-link-vid")
                };
                DOM.link_vid.on("click", function(e) {
                    e.preventDefault();
                    if ($(this).attr("data-video") == "to-play") {
                        $(this).attr("data-video", "to-pause");
                        let heightVidWrap = (0, _viewport.viewportBreak)({
                            desktop: DOM.vid_wrap.height(),
                            tablet: $(".home-showreel-main--inner").height()
                        });
                        let scrollTarget = DOM.stage.outerHeight() + DOM.stage.offset().top - $(window).height();
                        (0, _lenis.lenis).scrollTo(scrollTarget);
                        DOM.thumbnail.addClass("hidden");
                        DOM.video.removeClass("hidden");
                        DOM.play.addClass("hidden");
                        DOM.video.get(0).pause();
                        DOM.video.get(0).play();
                    } else {
                        $(this).attr("data-video", "to-play");
                        // $('.home-hero-vid-thumbnail').removeClass('hidden')
                        // $('.home-hero-vid-video').addClass('hidden')
                        //$('.home-hero-vid-thumbnail').find('video').get(0).play()
                        DOM.play.removeClass("hidden");
                        DOM.video.get(0).pause();
                    }
                });
                $(".home-showreel-play-wrapper").on("click", function(e) {
                    e.preventDefault();
                    DOM.link_vid.trigger("click");
                });
            }
            playShowreel();
            if ($(window).width() > 767) galleryZoom();
        }
        homeShowreel();
        /** (💡)  - SKILL */ function homeSkill() {
            ScrollTrigger.create({
                trigger: ".home-skill",
                start: "top bottom",
                end: "bottom top",
                toggleClass: {
                    targets: ".home-skill-thumb",
                    className: "active"
                }
            });
            ScrollTrigger.create({
                trigger: ".home-skill",
                start: "top bottom",
                once: true,
                onEnter: ()=>{
                    let titleTxt = new (0, _splitText.SplitText)(".home-skill-title", (0, _index.typeOpts).words);
                    let desc = new (0, _splitText.SplitText)(".home-skill-desc", (0, _index.typeOpts).words);
                    let tlSplitHead = gsap.timeline({
                        scrollTrigger: {
                            trigger: ".home-skill",
                            start: "top top+=80%",
                            endTrigger: ".home-skill-title",
                            end: "bottom top+=40%"
                        },
                        onComplete: ()=>{
                        // titleTxt.revert()
                        // desc.revert()
                        }
                    });
                    tlSplitHead.from(titleTxt.words, {
                        yPercent: 60,
                        autoAlpha: 0,
                        stagger: .035,
                        duration: .8,
                        ease: "power2.out"
                    }, 0).from(desc.words, {
                        yPercent: 60,
                        autoAlpha: 0,
                        stagger: .025,
                        duration: .8,
                        ease: "power2.out"
                    }, "<=.2");
                    $(".home-skill-item").each((idx, el)=>{
                        let itemTitleTxt = new (0, _splitText.SplitText)($(el).find(".home-skill-item-title"), (0, _index.typeOpts).chars);
                        tlSplitHead.from($(el).find(".line"), {
                            scaleX: 0,
                            transformOrigin: "left",
                            duration: 1,
                            ease: "power2.out"
                        }, `${.8 + idx * .2}`).from(itemTitleTxt.chars, {
                            yPercent: 60,
                            autoAlpha: 0,
                            stagger: .03,
                            duration: .6,
                            ease: "power2.out",
                            onComplete: ()=>{
                                itemTitleTxt.revert();
                            }
                        }, `${.8 + idx * .2}`);
                    });
                    $(".home-skill-thumb-item").each((idx, el)=>{
                        let clone = $(el).find("img");
                        for(let i = 1; i <= 5; i++){
                            let cloner = clone.clone();
                            cloner.addClass("cloner");
                            $(el).append(cloner);
                        }
                    });
                    if ($(window).width() > 991) {
                        $(".home-skill-item").on("mouseenter", function(e) {
                            let idx = $(this).index();
                            $(".home-skill-thumb").find(".home-skill-thumb-item").eq(idx).addClass("active");
                        });
                        $(".home-skill-item").on("mouseleave", function(e) {
                            let idx = $(this).index();
                            $(".home-skill-thumb").find(".home-skill-thumb-item").eq(idx).removeClass("active");
                        });
                        function initMouseMove() {
                            const target = $(".home-skill-thumb");
                            if (target.hasClass("active")) {
                                let tarCurrX = (0, _index.xGetter)(target.get(0));
                                let tarCurrY = (0, _index.yGetter)(target.get(0));
                                let tarCurrRot = (0, _index.rotZGetter)(target.get(0));
                                let tarX = -target.outerWidth() / 4 + ((0, _index.pointerCurr)().x - $(".home-skill-listing").get(0).getBoundingClientRect().left) / $(".home-skill-listing").outerWidth() * ($(".home-skill-listing").outerWidth() - $(".home-skill-item-desc").get(0).getBoundingClientRect().left - target.outerWidth() / 2);
                                let tarY = -target.outerHeight() / 4 + ((0, _index.pointerCurr)().y - $(".home-skill-listing").get(0).getBoundingClientRect().top) / $(".home-skill-listing").outerHeight() * ($(".home-skill-listing").outerHeight() - target.outerHeight() / 2);
                                (0, _index.xSetter)(target.get(0))((0, _index.lerp)(tarCurrX, tarX, .05));
                                (0, _index.ySetter)(target.get(0))((0, _index.lerp)(tarCurrY, tarY, .05));
                                (0, _index.rotZSetter)(target.get(0))((0, _index.lerp)(tarCurrRot, Math.min(Math.max((tarX - tarCurrX) / 40, -7), 7), .1));
                            }
                            requestAnimationFrame(initMouseMove);
                        }
                        requestAnimationFrame(initMouseMove);
                    } else {
                        let idx = 0;
                        $(".home-skill-item").eq(idx).addClass("active");
                        let skillSplitDes = new (0, _splitText.SplitText)($(".home-skill-item").eq(idx).find(".home-skill-item-desc"), (0, _index.typeOpts).words);
                        tlSplitHead.from(skillSplitDes.words, {
                            yPercent: 60,
                            autoAlpha: 0,
                            stagger: .02,
                            duration: .6,
                            ease: "power2.out",
                            onComplete: ()=>{
                                skillSplitDes.revert(), $(".home-skill-thumb").find(".home-skill-thumb-item").eq(idx).addClass("active");
                            }
                        }, "<=-.55");
                        if ($(window).width() > 767) $(".home-skill-item").on("click", function(e) {
                            e.preventDefault();
                            if (!$(this).hasClass("active")) {
                                $(".home-skill-item").removeClass("active");
                                $(this).addClass("active");
                                $(".home-skill-thumb").find(".home-skill-thumb-item").removeClass("active");
                                let idx = $(this).index();
                                $(".home-skill-thumb").find(".home-skill-thumb-item").eq(idx).addClass("active");
                                gsap.to(".home-skill-thumb", {
                                    y: (0, _viewport.cvUnit)(40, "rem") + ($(".home-skill-item").eq(0).outerHeight() - $(".home-skill-thumb").outerHeight()) / 2 + idx * $(".home-skill-item").eq(0).outerHeight(),
                                    duration: 1
                                });
                            } else {
                                $(".home-skill-thumb").find(".home-skill-thumb-item").removeClass("active");
                                $(".home-skill-item").removeClass("active");
                            }
                        });
                        else {
                            $(".home-skill-item").eq(idx).find(".home-skill-item-desc").slideDown(300, "linear");
                            gsap.to($(".home-skill-item").eq(idx), {
                                paddingTop: (0, _viewport.cvUnit)(27.5, "rem"),
                                paddingBottom: (0, _viewport.cvUnit)(27.5, "rem"),
                                duration: .3,
                                ease: "none",
                                overwrite: true
                            });
                            gsap.to($(".home-skill-item").eq(idx).find(".home-skill-item-title"), {
                                marginBottom: (0, _viewport.cvUnit)(12, "rem"),
                                duration: .3,
                                ease: "none",
                                overwrite: true
                            });
                            const target = $(".home-skill-thumb");
                            function clickMobileThumb() {
                                if (target.hasClass("active")) {
                                    let tarCurrY = (0, _index.yGetter)(target.get(0));
                                    let tarY = (0, _viewport.cvUnit)(60, "rem") - $(".home-skill-thumb").outerHeight() * 2.5 / 4 + ($(".home-skill-item").eq(idx).get(0).getBoundingClientRect().top - $(".home-skill-item").eq(0).get(0).getBoundingClientRect().top);
                                    (0, _index.ySetter)(target.get(0))((0, _index.lerp)(tarCurrY, tarY, .05));
                                }
                                requestAnimationFrame(clickMobileThumb);
                            }
                            clickMobileThumb();
                            $(".home-skill-item").on("click", function(e) {
                                e.preventDefault();
                                if (!$(this).hasClass("active")) {
                                    idx = $(this).index();
                                    $(".home-skill-item").removeClass("active");
                                    $(".home-skill-item .home-skill-item-desc").slideUp(300, "linear");
                                    $(this).addClass("active");
                                    $(this).find(".home-skill-item-desc").slideDown(300, "linear");
                                    gsap.to(".home-skill-item", {
                                        paddingTop: (0, _viewport.cvUnit)(60.5, "rem"),
                                        paddingBottom: (0, _viewport.cvUnit)(60.5, "rem"),
                                        duration: .3,
                                        ease: "none"
                                    });
                                    gsap.to(".home-skill-item .home-skill-item-title", {
                                        marginBottom: 0,
                                        duration: .3,
                                        ease: "none"
                                    });
                                    gsap.to(this, {
                                        paddingTop: (0, _viewport.cvUnit)(27.5, "rem"),
                                        paddingBottom: (0, _viewport.cvUnit)(27.5, "rem"),
                                        duration: .3,
                                        ease: "none",
                                        overwrite: true
                                    });
                                    gsap.to($(this).find(".home-skill-item-title"), {
                                        marginBottom: (0, _viewport.cvUnit)(12, "rem"),
                                        duration: .3,
                                        ease: "none",
                                        overwrite: true
                                    });
                                    $(".home-skill-thumb").find(".home-skill-thumb-item").removeClass("active");
                                    $(".home-skill-thumb").find(".home-skill-thumb-item").eq(idx).addClass("active");
                                } else {
                                    $(".home-skill-item").removeClass("active");
                                    $(".home-skill-item .home-skill-item-desc").slideUp(300, "linear");
                                    gsap.to(".home-skill-item", {
                                        paddingTop: (0, _viewport.cvUnit)(60.5, "rem"),
                                        paddingBottom: (0, _viewport.cvUnit)(60.5, "rem"),
                                        duration: .3,
                                        ease: "none"
                                    });
                                    gsap.to(".home-skill-item .home-skill-item-title", {
                                        marginBottom: 0,
                                        duration: .3,
                                        ease: "none"
                                    });
                                    $(".home-skill-thumb").find(".home-skill-thumb-item").removeClass("active");
                                }
                            });
                        }
                    }
                }
            });
        }
        homeSkill();
        /** (💡)  - PROCESS */ function homeProcess() {
            ScrollTrigger.create({
                trigger: ".home-process",
                start: "top bottom",
                once: true,
                onEnter: ()=>{
                    let titleTxt = new (0, _splitText.SplitText)(".home-process-title", (0, _index.typeOpts).chars);
                    let descTxt = new (0, _splitText.SplitText)(".home-process-desc", (0, _index.typeOpts).words);
                    let tlSplitHead = gsap.timeline({
                        scrollTrigger: {
                            trigger: ".home-process",
                            start: "top top+=80%",
                            // endTrigger: '.home-skill-title',
                            end: "bottom top+=40%"
                        },
                        onComplete: ()=>{
                            titleTxt.revert();
                            descTxt.revert();
                        }
                    });
                    tlSplitHead.from(titleTxt.chars, {
                        yPercent: 60,
                        autoAlpha: 0,
                        stagger: .035,
                        duration: .8,
                        ease: "power2.out"
                    }, 0);
                    if ($(window).width() > 767) {
                        tlSplitHead.from(".home-process-btn", {
                            yPercent: 50,
                            autoAlpha: 0,
                            duration: .8,
                            ease: "power2.out"
                        }, "<=.8");
                        tlSplitHead.from(descTxt.words, {
                            yPercent: 60,
                            autoAlpha: 0,
                            stagger: .025,
                            duration: .8,
                            ease: "power2.out"
                        }, "<=.2");
                    }
                    if ($(window).width() <= 767) {
                        tlSplitHead.from(descTxt.words, {
                            yPercent: 60,
                            autoAlpha: 0,
                            stagger: .025,
                            duration: .8,
                            ease: "power2.out"
                        }, "<=.5");
                        gsap.from(".home-process-btn", {
                            scrollTrigger: {
                                trigger: ".home-process-btn",
                                start: "top top+=80%"
                            },
                            yPercent: 50,
                            autoAlpha: 0,
                            duration: .8,
                            ease: "power2.out"
                        });
                    }
                    $(".home-process-step").each((idx, el)=>{
                        let clone = $(el).find(".img");
                        for(let i = 1; i <= 5; i++){
                            let cloner = clone.clone();
                            cloner.addClass("cloner");
                            $(el).find(".home-process-step-img").append(cloner);
                        }
                        let tl = gsap.timeline({
                            scrollTrigger: {
                                trigger: el,
                                start: "top top+=60%",
                                end: "bottom top+=70%",
                                scrub: .3
                            }
                        });
                        if (idx % 2 == 0) tl.from($(el).find(".home-process-step-background"), {
                            scale: 0,
                            borderRadius: "8rem",
                            ease: "sine.out",
                            duration: 4
                        }, 0).from($(el).find(".home-process-step-img"), {
                            autoAlpha: 0,
                            scale: .8,
                            yPercent: 20,
                            ease: "sine.inOut",
                            duration: 1
                        }, 2).from($(el).find(".home-process-step-label"), {
                            autoAlpha: 0,
                            ease: "sine.in",
                            duration: 1
                        }, "<=.2").from($(el).find(".home-process-step-title"), {
                            autoAlpha: 0,
                            ease: "sine.in",
                            duration: 1
                        }, "<=.4").from($(el).find(".home-process-step-desc"), {
                            autoAlpha: 0,
                            ease: "sine.in",
                            duration: 1
                        }, "<=.4");
                        else tl.from($(el).find(".home-process-step-background"), {
                            scale: 0,
                            borderRadius: "8rem",
                            ease: "sine.out",
                            duration: 4
                        }, 0).from($(el).find(".home-process-step-img"), {
                            autoAlpha: 0,
                            scale: .8,
                            yPercent: 20,
                            ease: "sine.inOut",
                            duration: 1
                        }, 2).from($(el).find(".home-process-step-label"), {
                            autoAlpha: 0,
                            ease: "sine.in",
                            duration: 1
                        }, "<=1.2").from($(el).find(".home-process-step-title"), {
                            autoAlpha: 0,
                            ease: "sine.in",
                            duration: 1
                        }, "<=.2").from($(el).find(".home-process-step-desc"), {
                            autoAlpha: 0,
                            ease: "sine.in",
                            duration: 1
                        }, "<=.2");
                    });
                }
            });
        }
        homeProcess();
        /** (💡)  - PORTFOLIO */ function homePortfolio() {
            function scrollAnimationGrid() {
                const gridItems = $(".home-portfolio-project-item");
                gridItems.each((idx, item)=>{
                    const yPercentRandomVal = gsap.utils.random(0, 60);
                    let tl = gsap.timeline({
                        scrollTrigger: {
                            trigger: item,
                            start: "top bottom",
                            end: "top top-=25%",
                            scrub: gsap.utils.random(.3, 1.4)
                        }
                    });
                    requestAnimationFrame(()=>{
                        tl.set(item, {
                            transformOrigin: `50% 200%`
                        }).fromTo(item, {
                            scale: 1,
                            yPercent: yPercentRandomVal
                        }, {
                            ease: "none",
                            scale: 0.5,
                            yPercent: 0,
                            borderRadius: "50%"
                        });
                    });
                });
            }
            scrollAnimationGrid();
            function changeTxtScrollAnim() {
                $(".home-portfolio-content-title .h0").each((idx, el)=>{
                    let tlChangeTxtScrollAnim = gsap.timeline({
                        scrollTrigger: {
                            trigger: ".home-portfolio-project",
                            start: `${(idx + 0) * $(".home-portfolio-project").height() / $(".home-portfolio-content-title .h0").length} top`,
                            end: `${(idx + 1) * $(".home-portfolio-project").height() / $(".home-portfolio-content-title .h0").length} top`,
                            onUpdate: ()=>{
                                $(".home-portfolio-content-title .h0").removeClass("active");
                                $(el).addClass("active");
                            }
                        }
                    });
                });
            }
            changeTxtScrollAnim();
            function hoverProject() {
                if ($(window).width() <= 991) changeProjHtml();
                const line = document.createElement("div");
                $(line).addClass("line");
                $(".home-project-item:last-child").append(line);
                const target = $(".home-project-thumb");
                ScrollTrigger.create({
                    trigger: ".home-project",
                    start: "top bottom",
                    end: "bottom top",
                    toggleClass: {
                        targets: target,
                        className: "active"
                    }
                });
                function projectClippath(index, action) {
                    let t = index / $(".home-project-wrap-bot .home-project-item").length * 100;
                    let b = (index + 1) / $(".home-project-wrap-bot .home-project-item").length * 100;
                    gsap.set(".home-project-wrap-top", {
                        clipPath: `polygon(0% ${t}%, 100% ${t}%, 100% ${b}%, 0% ${b}%)`
                    });
                }
                const targetMove = $(".home-project-wrap-top");
                gsap.set(targetMove, {
                    clipPath: `polygon(0 0, 100% 0, 100% 0, 0 0)`
                });
                if ($(window).width() > 991) {
                    $(".home-project-item").on("pointerleave", function(e) {
                        $(".home-project-thumb").find(`[data-thumb-name]`).removeClass("active");
                    });
                    $(".home-project-item").on("pointerenter", function(e) {
                        let nameSpace = $(this).find("[data-project-name]").attr("data-project-name");
                        $(".home-project-thumb").find(`[data-thumb-name]`).removeClass("active");
                        $(".home-project-thumb").find(`[data-thumb-name="${nameSpace}"]`).addClass("active");
                    });
                    $(".home-project-wrap-bot .home-project-item").on("pointerenter", function(e) {
                        let index = $(this).index();
                        projectClippath(index);
                    });
                    $(".home-project-wrap-bot .home-project-item").on("pointerleave", function(e) {
                        if (!$(".home-project-wrap-bot:hover").length && !$(".home-project-wrap-top:hover").length) {
                            if ($(this).is(":first-child")) {
                                let index = -1;
                                let t = index / $(".home-project-wrap-bot .home-project-item").length * 100;
                                let b = (index + 1) / $(".home-project-wrap-bot .home-project-item").length * 100;
                                gsap.set(".home-project-wrap-top", {
                                    clipPath: `polygon(0% ${t}%, 100% ${t}%, 100% ${b}%, 0% ${b}%)`
                                });
                            }
                            if ($(this).is(":last-child")) {
                                let index = $(".home-project-wrap-bot .home-project-item").length;
                                let t = index / $(".home-project-wrap-bot .home-project-item").length * 100;
                                let b = (index + 1) / $(".home-project-wrap-bot .home-project-item").length * 100;
                                gsap.set(".home-project-wrap-top", {
                                    clipPath: `polygon(0% ${t}%, 100% ${t}%, 100% ${b}%, 0% ${b}%)`
                                });
                            }
                        }
                    });
                    initMouseMove();
                } else {
                    $(".home-project-wrap-bot .home-project-item").each((idx, el)=>{
                        ScrollTrigger.create({
                            trigger: el,
                            start: "top center-=5%",
                            end: "bottom center-=5%",
                            // markers: true,
                            onLeave: ()=>{
                                if (idx == $(".home-project-wrap-bot .home-project-item").length - 1) {
                                    $(".home-project-thumb").find(`[data-thumb-name]`).removeClass("active");
                                    let index = $(".home-project-wrap-bot .home-project-item").length;
                                    let t = index / $(".home-project-wrap-bot .home-project-item").length * 100;
                                    let b = (index + 1) / $(".home-project-wrap-bot .home-project-item").length * 100;
                                    gsap.set(".home-project-wrap-top", {
                                        clipPath: `polygon(0% ${t}%, 100% ${t}%, 100% ${b}%, 0% ${b}%)`
                                    });
                                }
                            },
                            onLeaveBack: ()=>{
                                if (idx == 0) {
                                    $(".home-project-thumb").find(`[data-thumb-name]`).removeClass("active");
                                    let index = -1;
                                    let t = index / $(".home-project-wrap-bot .home-project-item").length * 100;
                                    let b = (index + 1) / $(".home-project-wrap-bot .home-project-item").length * 100;
                                    gsap.set(".home-project-wrap-top", {
                                        clipPath: `polygon(0% ${t}%, 100% ${t}%, 100% ${b}%, 0% ${b}%)`
                                    });
                                }
                            },
                            onUpdate: ()=>{
                                let nameSpace = $(el).find("[data-project-name]").attr("data-project-name");
                                $(".home-project-thumb").find(`[data-thumb-name]`).removeClass("active");
                                $(".home-project-thumb").find(`[data-thumb-name="${nameSpace}"]`).addClass("active");
                                let index = $(el).index();
                                projectClippath(index);
                                initClickThumb(index);
                            }
                        });
                    });
                    $(".home-project-wrap-bot .home-project-item").on("click", function(e) {
                        let nameSpace = $(this).find("[data-project-name]").attr("data-project-name");
                        $(".home-project-thumb").find(`[data-thumb-name]`).removeClass("active");
                        $(".home-project-thumb").find(`[data-thumb-name="${nameSpace}"]`).addClass("active");
                        let index = $(this).index();
                        projectClippath(index);
                        initClickThumb(index);
                    });
                }
                function initMouseMove() {
                    let offsetL = parseFloat(target.css("left"));
                    if (target.hasClass("active")) {
                        let tarCurrX = (0, _index.xGetter)(target.get(0));
                        let tarCurrY = (0, _index.yGetter)(target.get(0));
                        let tarCurrRot = (0, _index.rotZGetter)(target.get(0));
                        let tarX = (0, _index.pointerCurr)().x / $(".home-project").outerWidth() * ($(".home-project-item-view").get(0).getBoundingClientRect().left - offsetL - target.width());
                        let tarY = -target.height() / 4 + ((0, _index.pointerCurr)().y - $(".home-project").get(0).getBoundingClientRect().top) / $(".home-project").height() * ($(".home-project").height() - target.height() / 2);
                        (0, _index.xSetter)(target.get(0))((0, _index.lerp)(tarCurrX, tarX, .05));
                        (0, _index.ySetter)(target.get(0))((0, _index.lerp)(tarCurrY, tarY, .05));
                        (0, _index.rotZSetter)(target.get(0))((0, _index.lerp)(tarCurrRot, Math.min(Math.max((tarX - tarCurrX) / 20, -7), 7), .08));
                    }
                    requestAnimationFrame(initMouseMove);
                }
                function initClickThumb(idx) {
                    gsap.to(target, {
                        y: (0, _viewport.cvUnit)((0, _viewport.viewportBreak)({
                            tablet: 80,
                            mobile: 100
                        }), "rem") + ($(".home-project-item").eq(0).outerHeight() - target.outerHeight()) / 2 + idx * $(".home-project-item").eq(0).outerHeight(),
                        overwrite: true
                    });
                }
                function changeProjHtml() {
                    $(".home-project-item").each((idx, el)=>{
                        let targetItem = $(el);
                        let linkItem = $(el).find(".home-project-item-view");
                        let changeLink = $("<a>", {
                            html: linkItem.html(),
                            href: targetItem.attr("href"),
                            target: "_blank",
                            class: linkItem.attr("class")
                        });
                        linkItem.replaceWith(changeLink);
                        let changeTarget = $("<div>", {
                            html: targetItem.html(),
                            class: targetItem.attr("class")
                        });
                        targetItem.replaceWith(changeTarget);
                    });
                }
            }
            hoverProject();
            function projectCurtain() {
                let amount = 11;
                let offset = $(".home-curtain").height() / (amount - 1);
                const clone = $(".home-curtain-inner").eq(0);
                for(let i = 1; i < amount; i++){
                    let cloner = clone.clone();
                    $(".home-curtain").append(cloner);
                }
                let tl = gsap.timeline({
                    scrollTrigger: {
                        trigger: ".home-curtain",
                        start: "top bottom",
                        end: "top top-=70%",
                        scrub: true
                    },
                    defaults: {
                        ease: "none"
                    }
                });
                tl.to(".home-curtain-inner", {
                    scaleY: 1,
                    stagger: -0.1,
                    duration: 1,
                    y: -offset
                }, 0);
            }
            projectCurtain();
        }
        homePortfolio();
        /** (💡)  - PRICING */ function homePricing() {
            ScrollTrigger.create({
                trigger: ".home-pricing",
                start: "top bottom",
                once: true,
                onEnter: ()=>{
                    let labelTxt = new (0, _splitText.SplitText)(".home-pricing-text-label", (0, _index.typeOpts).chars);
                    let titleTxt = new (0, _splitText.SplitText)(".home-pricing-text-title", (0, _index.typeOpts).words);
                    let subTxt = new (0, _splitText.SplitText)(".home-pricing-text-sub", (0, _index.typeOpts).words);
                    let discountTxt = new (0, _splitText.SplitText)(".home-pricing-plan-discount", (0, _index.typeOpts).chars);
                    let tlSplitHead = gsap.timeline({
                        scrollTrigger: {
                            trigger: ".home-pricing",
                            start: "top top+=60%"
                        },
                        onComplete: ()=>{
                            titleTxt.revert();
                            subTxt.revert();
                            labelTxt.revert();
                            discountTxt.revert();
                        }
                    });
                    tlSplitHead.from(labelTxt.chars, {
                        yPercent: 60,
                        autoAlpha: 0,
                        stagger: .03,
                        duration: .6,
                        ease: "power2.out"
                    }, 0).from(titleTxt.words, {
                        yPercent: 60,
                        autoAlpha: 0,
                        stagger: .02,
                        duration: .6,
                        ease: "power2.out"
                    }, "<=.4").from(subTxt.words, {
                        yPercent: 60,
                        autoAlpha: 0,
                        stagger: .02,
                        duration: .6,
                        ease: "power2.out"
                    }, "<=.4").from(discountTxt.words, {
                        yPercent: 60,
                        autoAlpha: 0,
                        stagger: .02,
                        duration: .6,
                        ease: "power2.out"
                    }, "<=.6").from(".home-pricing-plan-switch", {
                        yPercent: 60,
                        autoAlpha: 0,
                        duration: .8,
                        ease: "power2.out",
                        clearProps: "all"
                    }, "<=.2");
                    let tlPricing = gsap.timeline({
                        scrollTrigger: {
                            trigger: ".home-pricing--wrap",
                            start: "top top+=70%"
                        }
                    });
                    tlPricing.from(".home-pricing-plan-item.popular", {
                        y: (0, _viewport.cvUnit)(60, "rem"),
                        autoAlpha: 0,
                        duration: .8,
                        ease: "power2.out",
                        clearProps: "all"
                    }, "<=1").from(".home-pricing-plan-item:not(.popular)", {
                        y: (0, _viewport.cvUnit)(60, "rem"),
                        autoAlpha: 0,
                        duration: .8,
                        ease: "power2.out",
                        clearProps: "all"
                    }, "<=.2");
                    let ctaHeadingTxt = new (0, _splitText.SplitText)(".home-pricing-plan-cta-heading", (0, _index.typeOpts).lines);
                    let ctaDescTxt = new (0, _splitText.SplitText)(".home-pricing-plan-cta-desc", (0, _index.typeOpts).lines);
                    let tlCTAHead = gsap.timeline({
                        scrollTrigger: {
                            trigger: ".home-pricing-plan-cta",
                            start: "top top+=80%"
                        },
                        onComplete: ()=>{
                            ctaHeadingTxt.revert();
                            ctaDescTxt.revert();
                        }
                    });
                    tlCTAHead.from(ctaHeadingTxt.lines, {
                        yPercent: 60,
                        autoAlpha: 0,
                        stagger: .3,
                        duration: .6,
                        ease: "power2.out"
                    }, 0).from(ctaDescTxt.lines, {
                        yPercent: 60,
                        autoAlpha: 0,
                        stagger: .2,
                        duration: .6,
                        ease: "power2.out"
                    }, "<=.3").from(".home-pricing-plan-cta .btn", {
                        yPercent: 60,
                        autoAlpha: 0,
                        stagger: .3,
                        duration: .6,
                        ease: "power2.out",
                        clearProps: "all"
                    }, "<=.3");
                }
            });
            function switchPlan() {
                const DOM = {
                    btnPlan: $(".home-pricing-plan-switch-wrap .home-pricing-plan-switch-btn"),
                    btnOverlay: $(".home-pricing-plan-switch-overlay"),
                    periodic: $(".home-pricing-plan-item-price-periodic"),
                    price: $(".home-pricing-plan-item-price-txt"),
                    btnPurchase: $(".home-pricing-plan-item-btn.btn-purchase")
                };
                function activePlan(index) {
                    gsap.to(DOM.btnOverlay, {
                        x: index * DOM.btnOverlay.width()
                    });
                    let tl = gsap.timeline();
                    tl.to(DOM.btnOverlay.eq(1), {
                        autoAlpha: .5
                    }).to(DOM.btnOverlay.eq(0), {
                        autoAlpha: 1
                    }, 0.2).to(DOM.btnOverlay.eq(1), {
                        autoAlpha: 1
                    }, 0.5).to(DOM.btnOverlay.eq(0), {
                        autoAlpha: 0
                    }, 0.5);
                    DOM.price.each((i, item)=>{
                        let text = $(item).find("h3");
                        text.removeClass("active");
                        text.eq(index).addClass("active");
                    });
                    DOM.periodic.each((i, item)=>{
                        let text = $(item).find("p");
                        text.removeClass("active");
                        text.eq(index).addClass("active");
                    });
                    let currPlan = DOM.btnPlan.eq(index).text();
                    DOM.btnPurchase.each((i, item)=>{
                        if ($(item).attr("data-purchase-method") === "trial") $(item).attr("data-purchase-id", 0);
                        else if ($(item).attr("data-purchase-method") === "subscription") {
                            let currLabel = $(item).siblings(".home-pricing-plan-item-label").text();
                            let planItemName = `${currLabel} ${currPlan}`;
                            (0, _planDataJsonDefault.default).forEach((_, idx)=>{
                                if ((0, _planDataJsonDefault.default)[idx].name.toLowerCase() === planItemName.toLowerCase()) $(item).attr("data-purchase-id", idx);
                            });
                        } else return;
                    });
                }
                activePlan(0);
                DOM.btnPlan.on("click", function(e) {
                    let index = $(this).index();
                    e.preventDefault();
                    activePlan(index);
                });
            }
            switchPlan();
            function testPayment() {
                $(".btn-purchase").on("click", function(e) {
                    e.preventDefault();
                    let planId = $(this).attr("data-purchase-id");
                    fetch("http://localhost:4000/create-checkout-session", {
                        method: "POST",
                        headers: {
                            "Content-Type": "application/json"
                        },
                        body: JSON.stringify({
                            items: [
                                {
                                    id: planId
                                }
                            ]
                        })
                    }).then((res)=>{
                        if (res.ok) return res.json();
                        return res.json().then((json)=>Promise.reject(json));
                    }).then(({ url })=>{
                        window.location = url;
                    }).catch((e)=>{
                        console.error(e.message);
                    });
                });
            }
            testPayment();
        }
        homePricing();
        /** (💡)  - INDUSTRIES */ function homeIndustries() {
            ScrollTrigger.create({
                trigger: ".home-explore",
                start: "top bottom",
                once: true,
                onEnter: ()=>{
                    let headTxt = new (0, _splitText.SplitText)(".home-explore-heading h3", (0, _index.typeOpts).chars);
                    let tlSplitHead = gsap.timeline({
                        scrollTrigger: {
                            trigger: ".home-explore-heading",
                            start: "top top+=90%",
                            end: "bottom top+=40%",
                            scrub: .1
                        }
                    });
                    tlSplitHead.from(headTxt.chars, {
                        color: "#121212",
                        stagger: .05,
                        duration: .6,
                        ease: "power1.out"
                    }, 0);
                    let titleTxt = new (0, _splitText.SplitText)(".home-explore-industries-title", (0, _index.typeOpts).words);
                    let tlSplitTitle = gsap.timeline({
                        scrollTrigger: {
                            trigger: ".home-explore-industries-title",
                            start: "top top+=95%"
                        }
                    });
                    tlSplitTitle.from(titleTxt.words, {
                        yPercent: 60,
                        autoAlpha: 0,
                        stagger: .02,
                        duration: .6,
                        ease: "power2.out"
                    }, 0);
                    if ($(window).width() > 991) {
                        function parallaxLogo() {
                            let target = $(".home-explore-img img");
                            let tarCurrX = (0, _index.xGetter)(target.get(0));
                            let tarCurrY = (0, _index.yGetter)(target.get(0));
                            let moveX = ((0, _index.pointerCurr)().x / $(window).width() - 0.5) * 2 * (target.width() / 4);
                            let moveY = ((0, _index.pointerCurr)().y / $(window).height() - 0.5) * 2 * (target.height() / 8);
                            (0, _index.xSetter)(target.get(0))((0, _index.lerp)(tarCurrX, moveX, .01));
                            (0, _index.ySetter)(target.get(0))((0, _index.lerp)(tarCurrY, moveY, .01));
                            requestAnimationFrame(parallaxLogo);
                        }
                        requestAnimationFrame(parallaxLogo);
                    } else gsap.fromTo(".home-explore-img img", {
                        yPercent: (0, _viewport.viewportBreak)({
                            tablet: 20,
                            mobile: 40
                        })
                    }, {
                        scrollTrigger: {
                            trigger: ".home-explore-heading",
                            start: "top bottom",
                            end: "bottom top",
                            scrub: .2
                        },
                        yPercent: -50,
                        ease: "none"
                    });
                    const DOM = {
                        radarScan: $(".home-explore-industries-radar-scan"),
                        lineItem: $(".home-explore-industries-radar-wrapper-item-line"),
                        dot: $(".home-explore-industries-radar-wrapper-item-line-dot-wrap")
                    };
                    gsap.set(DOM.radarScan, {
                        rotate: -10
                    });
                    let lifeCycleTime = 8;
                    let tl = gsap.timeline({
                        repeat: -1,
                        defaults: {
                            ease: "none"
                        }
                    });
                    tl.fromTo(DOM.radarScan, {
                        rotate: -10
                    }, {
                        rotate: 260,
                        duration: lifeCycleTime,
                        ease: "none"
                    }, 0);
                    DOM.lineItem.each((idx, el)=>{
                        tl.to($(el).find(DOM.dot), {
                            onStart: ()=>{
                                $(el).find(DOM.dot).addClass("active");
                            }
                        }, `${0.1254480287 * lifeCycleTime + 0.1111111111 * idx * lifeCycleTime}`).to($(el).find(DOM.dot), {
                            onStart: ()=>{
                                $(el).find(DOM.dot).removeClass("active");
                            }
                        }, "<=2");
                    });
                    $(".home-explore-industries-radar-wrapper-item-line-dot-wrap").on("pointerenter", function(e) {
                        $(this).addClass("on-hover");
                    });
                    $(".home-explore-industries-radar-wrapper-item-line-dot-wrap").on("pointerleave", function(e) {
                        $(this).removeClass("on-hover");
                    });
                }
            });
        }
        homeIndustries();
        /** (💡)  - TESTIMONIAL */ function homeTesti() {
            if ($(window).width() > 767) {
                $(".home-testi").css("height", +$(window).height() + $(".home-testi-content-item").eq(0).height() * 1.5 * $(".home-testi-content-item").length + "px");
                let tl = gsap.timeline({
                    scrollTrigger: {
                        trigger: ".home-testi",
                        start: `top top`,
                        end: "bottom bottom",
                        scrub: .1,
                        onUpdate: (timeline)=>{
                            gsap.set(".home-testi-content-progress-inner", {
                                y: timeline.progress * (0, _viewport.cvUnit)(180, "rem")
                            });
                        }
                    }
                });
                tl.fromTo(".home-testi-text-wrap", {
                    y: (0, _viewport.cvUnit)(-100, "rem")
                }, {
                    y: (0, _viewport.cvUnit)(-90, "rem"),
                    ease: "none"
                });
                let tlScrub = gsap.timeline({
                    scrollTrigger: {
                        trigger: ".home-testi",
                        start: `top bottom`,
                        end: "bottom top",
                        scrub: .2,
                        snap: {
                            // To update exact position and check directional
                            snapTo (value) {
                                if (value > 0.1822 && value <= 0.3644) return 0.2521;
                                else if (value > 0.3644 && value <= 0.5512) return 0.4767;
                                else if (value > 0.5512 && value <= 0.69445) return 0.6257;
                                else if (value > 0.69445 && value <= 0.8816) return 0.7632;
                                else return value;
                            },
                            // snapTo: [0.2521, 0.4767, 0.6257, 0.7632],
                            duration: {
                                min: 0.15,
                                max: 1
                            },
                            delay: 0.01
                        }
                    }
                });
                let timeDelay = 0;
                let timeAnim = 1;
                let zUnit;
                let yUnit;
                if ($(window).width() > 991) {
                    zUnit = 600;
                    yUnit = 90;
                } else {
                    zUnit = 1200;
                    yUnit = 100;
                }
                $(".home-testi-content-item").each((idx, el)=>{
                    if (idx == 0) tlScrub.fromTo($(el), {
                        z: (0, _viewport.cvUnit)(zUnit * 2, "rem"),
                        yPercent: 75,
                        filter: "brightness(1)"
                    }, {
                        z: 0,
                        yPercent: 0,
                        filter: "brightness(1)",
                        ease: "power1.out",
                        duration: timeAnim * 2
                    }, 0);
                    if (idx > 0 && idx < $(".home-testi-content-item").length) {
                        tlScrub.fromTo($(el), {
                            z: (0, _viewport.cvUnit)(zUnit, "rem"),
                            yPercent: 150,
                            filter: "brightness(1)"
                        }, {
                            z: 0,
                            yPercent: 0,
                            filter: "brightness(1)",
                            ease: "power3.out",
                            duration: timeAnim
                        }, `>=${timeDelay}`).fromTo($(el).prev(), {
                            z: 0,
                            y: 0,
                            filter: "brightness(1)"
                        }, {
                            z: (0, _viewport.cvUnit)(-zUnit, "rem"),
                            y: (0, _viewport.cvUnit)(-yUnit, "rem"),
                            filter: "brightness(.67)",
                            ease: "power2.out",
                            duration: timeAnim
                        }, "<=0");
                        if (idx > 1) tlScrub.fromTo($(el).prev().prev(), {
                            z: (0, _viewport.cvUnit)(-zUnit, "rem"),
                            y: (0, _viewport.cvUnit)(-yUnit, "rem"),
                            filter: "brightness(.67)"
                        }, {
                            z: (0, _viewport.cvUnit)(-zUnit * 2, "rem"),
                            y: (0, _viewport.cvUnit)(-yUnit * 2, "rem"),
                            filter: "brightness(.33)",
                            ease: "power2.out",
                            duration: timeAnim
                        }, "<=0");
                        if (idx > 2) tlScrub.fromTo($(el).prev().prev().prev(), {
                            z: (0, _viewport.cvUnit)(-zUnit * 2, "rem"),
                            y: (0, _viewport.cvUnit)(-yUnit * 2, "rem"),
                            filter: "brightness(.33)"
                        }, {
                            z: (0, _viewport.cvUnit)(-zUnit * 3, "rem"),
                            y: (0, _viewport.cvUnit)(-yUnit * 3, "rem"),
                            filter: "brightness(0)",
                            ease: "power2.out",
                            duration: timeAnim
                        }, "<=0");
                    }
                    if (idx == $(".home-testi-content-item").length - 1) tlScrub.fromTo($(el), {
                        z: 0,
                        y: 0,
                        filter: "brightness(1)"
                    }, {
                        z: (0, _viewport.cvUnit)(-zUnit, "rem"),
                        y: (0, _viewport.cvUnit)(-yUnit, "rem"),
                        filter: "brightness(.67)",
                        ease: "power3.out",
                        duration: timeAnim
                    }, `>=${timeDelay}`).fromTo($(el).prev(), {
                        z: (0, _viewport.cvUnit)(-zUnit, "rem"),
                        y: (0, _viewport.cvUnit)(-yUnit, "rem"),
                        filter: "brightness(.67)"
                    }, {
                        z: (0, _viewport.cvUnit)(-zUnit * 2, "rem"),
                        y: (0, _viewport.cvUnit)(-yUnit * 2, "rem"),
                        filter: "brightness(.33)",
                        ease: "power3.out",
                        duration: timeAnim
                    }, "<=0").fromTo($(el).prev().prev(), {
                        z: (0, _viewport.cvUnit)(-zUnit * 2, "rem"),
                        y: (0, _viewport.cvUnit)(-yUnit * 2, "rem"),
                        filter: "brightness(.33)"
                    }, {
                        z: (0, _viewport.cvUnit)(-zUnit * 3, "rem"),
                        y: (0, _viewport.cvUnit)(-yUnit * 3, "rem"),
                        filter: "brightness(0)",
                        ease: "power3.out",
                        duration: timeAnim
                    }, "<=0");
                });
                gsap.set(".home-testi-content-item", {
                    z: 0,
                    y: 0,
                    filter: "brightness(1)"
                });
            } else {
                let parent = $(".home-testi-content");
                parent.find('[data-swiper="swiper"]').addClass("swiper");
                parent.find('[data-swiper="swiper-wrapper"]').addClass("swiper-wrapper");
                parent.find('[data-swiper="swiper-slide"]').addClass("swiper-slide");
                new Swiper(".home-testi-content-wrap", {
                    spaceBetween: (0, _viewport.cvUnit)(20, "rem"),
                    slidesPerView: 1,
                    scrollbar: {
                        el: ".home-testi-content-progress"
                    }
                });
            }
        }
        homeTesti();
        /** (💡)  - FAQ */ function homeFaq() {
            function accordion() {
                const parent = (0, _index.selector)(".home-faq-content-listing");
                const DOM = {
                    accordion: parent(".home-faq-content-item"),
                    accordionTitle: parent(".home-faq-content-item-ques"),
                    accordionContent: parent(".home-faq-content-item-answer")
                };
                parent(DOM.accordionContent).hide();
                function activeAccordion(index) {
                    DOM.accordionContent.eq(index).slideToggle("slow");
                    DOM.accordion.eq(index).toggleClass("active");
                    DOM.accordionContent.not(DOM.accordionContent.eq(index)).slideUp("slow");
                    DOM.accordion.not(DOM.accordion.eq(index)).removeClass("active");
                }
                DOM.accordionTitle.on("click", function() {
                    let index = $(this).parent().index();
                    activeAccordion(index);
                });
            }
            accordion();
        }
        homeFaq();
    },
    beforeLeave () {
        console.log(`leave ${this.namespace}`);
    }
};
exports.default = home;

},{"../../helper/index":"9hx9E","../../helper/viewport":"1S9hW","../../global/lenis":"Er3Ar","../../../../plan-data.json":"BTR1D","../../libs/SplitText":"g3xEb","@parcel/transformer-js/src/esmodule-helpers.js":"81AKE"}],"9hx9E":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "lerp", ()=>lerp);
parcelHelpers.export(exports, "parseRem", ()=>parseRem);
parcelHelpers.export(exports, "xSetter", ()=>xSetter);
parcelHelpers.export(exports, "ySetter", ()=>ySetter);
parcelHelpers.export(exports, "scaleXSetter", ()=>scaleXSetter);
parcelHelpers.export(exports, "scaleYSetter", ()=>scaleYSetter);
parcelHelpers.export(exports, "rotZSetter", ()=>rotZSetter);
parcelHelpers.export(exports, "xGetter", ()=>xGetter);
parcelHelpers.export(exports, "yGetter", ()=>yGetter);
parcelHelpers.export(exports, "scaleXGetter", ()=>scaleXGetter);
parcelHelpers.export(exports, "scaleYGetter", ()=>scaleYGetter);
parcelHelpers.export(exports, "selector", ()=>selector);
parcelHelpers.export(exports, "rotZGetter", ()=>rotZGetter);
parcelHelpers.export(exports, "typeOpts", ()=>typeOpts);
parcelHelpers.export(exports, "pointerCurr", ()=>pointerCurr);
parcelHelpers.export(exports, "findClosestEdge", ()=>findClosestEdge);
parcelHelpers.export(exports, "closestEdge", ()=>closestEdge);
parcelHelpers.export(exports, "distMetric", ()=>distMetric);
parcelHelpers.export(exports, "FloatingAnimation", ()=>FloatingAnimation);
parcelHelpers.export(exports, "debounce", ()=>debounce);
var _viewport = require("../helper/viewport");
const lerp = (a, b, t = 0.08)=>{
    return a + (b - a) * t;
};
const parseRem = (input)=>{
    return input / 10 * parseFloat($("html").css("font-size"));
};
const xSetter = (el)=>gsap.quickSetter(el, "x", `px`);
const ySetter = (el)=>gsap.quickSetter(el, "y", `px`);
const scaleXSetter = (el)=>gsap.quickSetter(el, "scaleX");
const scaleYSetter = (el)=>gsap.quickSetter(el, "scaleY");
const rotZSetter = (el)=>gsap.quickSetter(el, "rotateZ", `deg`);
const xGetter = (el)=>gsap.getProperty(el, "x");
const yGetter = (el)=>gsap.getProperty(el, "y");
const scaleXGetter = (el)=>gsap.getProperty(el, "scaleX");
const scaleYGetter = (el)=>gsap.getProperty(el, "scaleY");
const rotZGetter = (el)=>gsap.getProperty(el, "rotateZ");
const selector = (parent)=>{
    return (child)=>$(parent).find(child);
};
let typeOpts = {
    lines: {
        type: "lines",
        linesClass: "g-lines"
    },
    words: {
        type: "words,lines",
        linesClass: "g-lines"
    },
    chars: {
        type: "chars,words,lines",
        linesClass: "g-lines"
    }
};
let pointer = {
    x: $(window).width() / 2,
    y: $(window).height() / 2
};
$(window).on("pointermove", function(e) {
    pointer.x = e.clientX;
    pointer.y = e.clientY;
    if ($(".cursor-wrap").hasClass("on-hidden") && !(0, _viewport.isTouchDevice)() && $(window).width() > 991) $(".cursor-wrap").removeClass("on-hidden");
});
const pointerCurr = ()=>{
    return pointer;
};
function debounce(func, delay = 100) {
    let timer;
    return function(event) {
        if (timer) clearTimeout(timer);
        timer = setTimeout(func, delay, event);
    };
}
const findClosestEdge = (ev, el)=>{
    if (!el) return;
    const wrapperRect = el.getBoundingClientRect();
    const x = ev.clientX - wrapperRect.left;
    const y = ev.clientY - wrapperRect.top;
    return closestEdge(x, y, el.clientWidth, el.clientHeight);
};
const closestEdge = (x, y, w, h)=>{
    const topEdgeDist = distMetric(x, y, w / 2, 0);
    const bottomEdgeDist = distMetric(x, y, w / 2, h);
    const min = Math.min(topEdgeDist, bottomEdgeDist);
    return min === topEdgeDist ? "top" : "bottom";
};
const distMetric = (x, y, x2, y2)=>{
    var xDiff = x - x2;
    var yDiff = y - y2;
    return xDiff * xDiff + yDiff * yDiff;
};
class FloatingAnimation {
    random(min, max) {
        return (direction = 1)=>(max - Math.random() * (max - min)) * direction;
    }
    moveX(selector, direction) {
        gsap.to(selector, {
            duration: this.random(this.duration * 0.5, this.duration),
            x: this.random(this.x * 0.1, this.x),
            ease: "sine.inOut",
            onComplete: this.moveX.bind(this),
            onCompleteParams: [
                selector,
                direction * -1
            ]
        });
    }
    moveY(selector, direction) {
        gsap.to(selector, {
            duration: this.random(this.y * 0.1, this.y),
            y: this.random(this.y * 0.1, this.y),
            ease: "sine.inOut",
            onComplete: this.moveY.bind(this),
            onCompleteParams: [
                selector,
                direction * -1
            ]
        });
    }
    rotate(selector, direction) {
        gsap.to(selector, {
            duration: this.random(this.x * 0.1, this.x),
            rotation: this.random(this.angle * 0.1, this.angle),
            ease: "sine.inOut",
            onComplete: this.rotate.bind(this),
            onCompleteParams: [
                selector,
                direction * -1
            ]
        });
    }
    constructor(target, x, y, angle, duration){
        this.target = $(target);
        this.x = x || 50;
        this.y = y || 50;
        this.angle = angle || 15;
        this.duration = duration || 10;
        this.randomX = this.random(this.x * 0.1, this.x);
        this.randomY = this.random(this.y * 0.1, this.y);
        this.randomAngle = this.random(this.angle * 0.1, this.angle);
        this.randomMoveTime = this.random(this.duration * 0.5, this.duration);
        this.randomRotateTime = this.random(this.duration, this.duration * 2);
        gsap.set(this.target, {
            transformOrigin: "center center"
        });
        this.moveX(this.target, Math.random() < 0.5 ? 1 : -1);
        this.moveY(this.target, Math.random() < 0.5 ? 1 : -1);
        this.rotate(this.target, Math.random() < 0.5 ? 1 : -1);
    }
}

},{"../helper/viewport":"1S9hW","@parcel/transformer-js/src/esmodule-helpers.js":"81AKE"}],"1S9hW":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "viewport", ()=>viewport);
parcelHelpers.export(exports, "viewportBreak", ()=>viewportBreak);
parcelHelpers.export(exports, "isTouchDevice", ()=>isTouchDevice);
parcelHelpers.export(exports, "cvUnit", ()=>cvUnit);
parcelHelpers.export(exports, "percentage", ()=>percentage);
let viewport = {
    width: $(window).width(),
    height: $(window).height(),
    pixelRatio: window.devicePixelRatio
};
const device = {
    tablet: 991,
    mobile: 767
};
const viewportBreak = (callbacks)=>{
    const { desktop, tablet, mobile } = callbacks;
    let result;
    switch(true){
        case viewport.width >= device.tablet:
            result = callbacks.desktop;
            break;
        case viewport.width >= device.mobile:
            result = callbacks.tablet;
            break;
        default:
            result = callbacks.mobile;
            break;
    }
    return result instanceof Function ? result() : result;
};
const cvUnit = (val, unit)=>{
    let result;
    switch(true){
        case unit === "vw":
            result = $(window).width() * (val / 100);
            break;
        case unit === "vh":
            result = $(window).height() * (val / 100);
            break;
        case unit === "rem":
            result = val / 10 * parseFloat($("html").css("font-size"));
            break;
        default:
            break;
    }
    return result;
};
const percentage = (percent, total)=>(percent / 100 * total).toFixed(2);
const isTouchDevice = ()=>{
    return "ontouchstart" in window || navigator.maxTouchPoints > 0 || navigator.msMaxTouchPoints > 0;
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"81AKE"}],"81AKE":[function(require,module,exports) {
exports.interopDefault = function(a) {
    return a && a.__esModule ? a : {
        default: a
    };
};
exports.defineInteropFlag = function(a) {
    Object.defineProperty(a, "__esModule", {
        value: true
    });
};
exports.exportAll = function(source, dest) {
    Object.keys(source).forEach(function(key) {
        if (key === "default" || key === "__esModule" || Object.prototype.hasOwnProperty.call(dest, key)) return;
        Object.defineProperty(dest, key, {
            enumerable: true,
            get: function() {
                return source[key];
            }
        });
    });
    return dest;
};
exports.export = function(dest, destName, get) {
    Object.defineProperty(dest, destName, {
        enumerable: true,
        get: get
    });
};

},{}],"Er3Ar":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "lenis", ()=>lenis);
parcelHelpers.export(exports, "initLenis", ()=>initLenis);
gsap.registerPlugin(ScrollTrigger);
let lenis;
const initLenis = ()=>{
    lenis = new Lenis();
    lenis.on("scroll", ScrollTrigger.update);
    gsap.ticker.add((time)=>{
        lenis.raf(time * 1000);
    });
    gsap.ticker.lagSmoothing(0);
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"81AKE"}],"BTR1D":[function(require,module,exports) {
module.exports = JSON.parse('[{"priceId":"price_1OgOlkAyaaWxy2CsqsoJipuR","name":"Trial 7 days","method":"payment","scope":"Design Only"},{"priceId":"price_1OfJjyAyaaWxy2CsH7LieoXV","name":"Standard Monthly","method":"subscription","scope":"Design Only"},{"priceId":"price_1OgOfAAyaaWxy2CsHMFYrhRS","name":"Standard Quarterly","method":"subscription","scope":"Design Only"},{"priceId":"price_1OgOgRAyaaWxy2CsaQOuzcu3","name":"Standard Yearly","method":"subscription","scope":"Design Only"},{"priceId":"price_1OgOibAyaaWxy2CsxHJUR1MI","name":"Pro Monthly","method":"subscription","scope":"Design & Development"},{"priceId":"price_1OgOkKAyaaWxy2Cs6A2eJGKE","name":"Pro Quarterly","method":"subscription","scope":"Design & Development"},{"priceId":"price_1OgOl3AyaaWxy2Csxdyz1Lbn","name":"Pro Yearly","method":"subscription","scope":"Design & Development"}]');

},{}],"g3xEb":[function(require,module,exports) {
(function(global, factory) {
    factory(exports);
})(this, function(exports1) {
    "use strict";
    var emojiExp = /([\uD800-\uDBFF][\uDC00-\uDFFF](?:[\u200D\uFE0F][\uD800-\uDBFF][\uDC00-\uDFFF]){2,}|\uD83D\uDC69(?:\u200D(?:(?:\uD83D\uDC69\u200D)?\uD83D\uDC67|(?:\uD83D\uDC69\u200D)?\uD83D\uDC66)|\uD83C[\uDFFB-\uDFFF])|\uD83D\uDC69\u200D(?:\uD83D\uDC69\u200D)?\uD83D\uDC66\u200D\uD83D\uDC66|\uD83D\uDC69\u200D(?:\uD83D\uDC69\u200D)?\uD83D\uDC67\u200D(?:\uD83D[\uDC66\uDC67])|\uD83C\uDFF3\uFE0F\u200D\uD83C\uDF08|(?:\uD83C[\uDFC3\uDFC4\uDFCA]|\uD83D[\uDC6E\uDC71\uDC73\uDC77\uDC81\uDC82\uDC86\uDC87\uDE45-\uDE47\uDE4B\uDE4D\uDE4E\uDEA3\uDEB4-\uDEB6]|\uD83E[\uDD26\uDD37-\uDD39\uDD3D\uDD3E\uDDD6-\uDDDD])(?:\uD83C[\uDFFB-\uDFFF])\u200D[\u2640\u2642]\uFE0F|\uD83D\uDC69(?:\uD83C[\uDFFB-\uDFFF])\u200D(?:\uD83C[\uDF3E\uDF73\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92])|(?:\uD83C[\uDFC3\uDFC4\uDFCA]|\uD83D[\uDC6E\uDC6F\uDC71\uDC73\uDC77\uDC81\uDC82\uDC86\uDC87\uDE45-\uDE47\uDE4B\uDE4D\uDE4E\uDEA3\uDEB4-\uDEB6]|\uD83E[\uDD26\uDD37-\uDD39\uDD3C-\uDD3E\uDDD6-\uDDDF])\u200D[\u2640\u2642]\uFE0F|\uD83C\uDDFD\uD83C\uDDF0|\uD83C\uDDF6\uD83C\uDDE6|\uD83C\uDDF4\uD83C\uDDF2|\uD83C\uDDE9(?:\uD83C[\uDDEA\uDDEC\uDDEF\uDDF0\uDDF2\uDDF4\uDDFF])|\uD83C\uDDF7(?:\uD83C[\uDDEA\uDDF4\uDDF8\uDDFA\uDDFC])|\uD83C\uDDE8(?:\uD83C[\uDDE6\uDDE8\uDDE9\uDDEB-\uDDEE\uDDF0-\uDDF5\uDDF7\uDDFA-\uDDFF])|(?:\u26F9|\uD83C[\uDFCB\uDFCC]|\uD83D\uDD75)(?:\uFE0F\u200D[\u2640\u2642]|(?:\uD83C[\uDFFB-\uDFFF])\u200D[\u2640\u2642])\uFE0F|(?:\uD83D\uDC41\uFE0F\u200D\uD83D\uDDE8|\uD83D\uDC69(?:\uD83C[\uDFFB-\uDFFF])\u200D[\u2695\u2696\u2708]|\uD83D\uDC69\u200D[\u2695\u2696\u2708]|\uD83D\uDC68(?:(?:\uD83C[\uDFFB-\uDFFF])\u200D[\u2695\u2696\u2708]|\u200D[\u2695\u2696\u2708]))\uFE0F|\uD83C\uDDF2(?:\uD83C[\uDDE6\uDDE8-\uDDED\uDDF0-\uDDFF])|\uD83D\uDC69\u200D(?:\uD83C[\uDF3E\uDF73\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\u2764\uFE0F\u200D(?:\uD83D\uDC8B\u200D(?:\uD83D[\uDC68\uDC69])|\uD83D[\uDC68\uDC69]))|\uD83C\uDDF1(?:\uD83C[\uDDE6-\uDDE8\uDDEE\uDDF0\uDDF7-\uDDFB\uDDFE])|\uD83C\uDDEF(?:\uD83C[\uDDEA\uDDF2\uDDF4\uDDF5])|\uD83C\uDDED(?:\uD83C[\uDDF0\uDDF2\uDDF3\uDDF7\uDDF9\uDDFA])|\uD83C\uDDEB(?:\uD83C[\uDDEE-\uDDF0\uDDF2\uDDF4\uDDF7])|[#\*0-9]\uFE0F\u20E3|\uD83C\uDDE7(?:\uD83C[\uDDE6\uDDE7\uDDE9-\uDDEF\uDDF1-\uDDF4\uDDF6-\uDDF9\uDDFB\uDDFC\uDDFE\uDDFF])|\uD83C\uDDE6(?:\uD83C[\uDDE8-\uDDEC\uDDEE\uDDF1\uDDF2\uDDF4\uDDF6-\uDDFA\uDDFC\uDDFD\uDDFF])|\uD83C\uDDFF(?:\uD83C[\uDDE6\uDDF2\uDDFC])|\uD83C\uDDF5(?:\uD83C[\uDDE6\uDDEA-\uDDED\uDDF0-\uDDF3\uDDF7-\uDDF9\uDDFC\uDDFE])|\uD83C\uDDFB(?:\uD83C[\uDDE6\uDDE8\uDDEA\uDDEC\uDDEE\uDDF3\uDDFA])|\uD83C\uDDF3(?:\uD83C[\uDDE6\uDDE8\uDDEA-\uDDEC\uDDEE\uDDF1\uDDF4\uDDF5\uDDF7\uDDFA\uDDFF])|\uD83C\uDFF4\uDB40\uDC67\uDB40\uDC62(?:\uDB40\uDC77\uDB40\uDC6C\uDB40\uDC73|\uDB40\uDC73\uDB40\uDC63\uDB40\uDC74|\uDB40\uDC65\uDB40\uDC6E\uDB40\uDC67)\uDB40\uDC7F|\uD83D\uDC68(?:\u200D(?:\u2764\uFE0F\u200D(?:\uD83D\uDC8B\u200D)?\uD83D\uDC68|(?:(?:\uD83D[\uDC68\uDC69])\u200D)?\uD83D\uDC66\u200D\uD83D\uDC66|(?:(?:\uD83D[\uDC68\uDC69])\u200D)?\uD83D\uDC67\u200D(?:\uD83D[\uDC66\uDC67])|\uD83C[\uDF3E\uDF73\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92])|(?:\uD83C[\uDFFB-\uDFFF])\u200D(?:\uD83C[\uDF3E\uDF73\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]))|\uD83C\uDDF8(?:\uD83C[\uDDE6-\uDDEA\uDDEC-\uDDF4\uDDF7-\uDDF9\uDDFB\uDDFD-\uDDFF])|\uD83C\uDDF0(?:\uD83C[\uDDEA\uDDEC-\uDDEE\uDDF2\uDDF3\uDDF5\uDDF7\uDDFC\uDDFE\uDDFF])|\uD83C\uDDFE(?:\uD83C[\uDDEA\uDDF9])|\uD83C\uDDEE(?:\uD83C[\uDDE8-\uDDEA\uDDF1-\uDDF4\uDDF6-\uDDF9])|\uD83C\uDDF9(?:\uD83C[\uDDE6\uDDE8\uDDE9\uDDEB-\uDDED\uDDEF-\uDDF4\uDDF7\uDDF9\uDDFB\uDDFC\uDDFF])|\uD83C\uDDEC(?:\uD83C[\uDDE6\uDDE7\uDDE9-\uDDEE\uDDF1-\uDDF3\uDDF5-\uDDFA\uDDFC\uDDFE])|\uD83C\uDDFA(?:\uD83C[\uDDE6\uDDEC\uDDF2\uDDF3\uDDF8\uDDFE\uDDFF])|\uD83C\uDDEA(?:\uD83C[\uDDE6\uDDE8\uDDEA\uDDEC\uDDED\uDDF7-\uDDFA])|\uD83C\uDDFC(?:\uD83C[\uDDEB\uDDF8])|(?:\u26F9|\uD83C[\uDFCB\uDFCC]|\uD83D\uDD75)(?:\uD83C[\uDFFB-\uDFFF])|(?:\uD83C[\uDFC3\uDFC4\uDFCA]|\uD83D[\uDC6E\uDC71\uDC73\uDC77\uDC81\uDC82\uDC86\uDC87\uDE45-\uDE47\uDE4B\uDE4D\uDE4E\uDEA3\uDEB4-\uDEB6]|\uD83E[\uDD26\uDD37-\uDD39\uDD3D\uDD3E\uDDD6-\uDDDD])(?:\uD83C[\uDFFB-\uDFFF])|(?:[\u261D\u270A-\u270D]|\uD83C[\uDF85\uDFC2\uDFC7]|\uD83D[\uDC42\uDC43\uDC46-\uDC50\uDC66\uDC67\uDC70\uDC72\uDC74-\uDC76\uDC78\uDC7C\uDC83\uDC85\uDCAA\uDD74\uDD7A\uDD90\uDD95\uDD96\uDE4C\uDE4F\uDEC0\uDECC]|\uD83E[\uDD18-\uDD1C\uDD1E\uDD1F\uDD30-\uDD36\uDDD1-\uDDD5])(?:\uD83C[\uDFFB-\uDFFF])|\uD83D\uDC68(?:\u200D(?:(?:(?:\uD83D[\uDC68\uDC69])\u200D)?\uD83D\uDC67|(?:(?:\uD83D[\uDC68\uDC69])\u200D)?\uD83D\uDC66)|\uD83C[\uDFFB-\uDFFF])|(?:[\u261D\u26F9\u270A-\u270D]|\uD83C[\uDF85\uDFC2-\uDFC4\uDFC7\uDFCA-\uDFCC]|\uD83D[\uDC42\uDC43\uDC46-\uDC50\uDC66-\uDC69\uDC6E\uDC70-\uDC78\uDC7C\uDC81-\uDC83\uDC85-\uDC87\uDCAA\uDD74\uDD75\uDD7A\uDD90\uDD95\uDD96\uDE45-\uDE47\uDE4B-\uDE4F\uDEA3\uDEB4-\uDEB6\uDEC0\uDECC]|\uD83E[\uDD18-\uDD1C\uDD1E\uDD1F\uDD26\uDD30-\uDD39\uDD3D\uDD3E\uDDD1-\uDDDD])(?:\uD83C[\uDFFB-\uDFFF])?|(?:[\u231A\u231B\u23E9-\u23EC\u23F0\u23F3\u25FD\u25FE\u2614\u2615\u2648-\u2653\u267F\u2693\u26A1\u26AA\u26AB\u26BD\u26BE\u26C4\u26C5\u26CE\u26D4\u26EA\u26F2\u26F3\u26F5\u26FA\u26FD\u2705\u270A\u270B\u2728\u274C\u274E\u2753-\u2755\u2757\u2795-\u2797\u27B0\u27BF\u2B1B\u2B1C\u2B50\u2B55]|\uD83C[\uDC04\uDCCF\uDD8E\uDD91-\uDD9A\uDDE6-\uDDFF\uDE01\uDE1A\uDE2F\uDE32-\uDE36\uDE38-\uDE3A\uDE50\uDE51\uDF00-\uDF20\uDF2D-\uDF35\uDF37-\uDF7C\uDF7E-\uDF93\uDFA0-\uDFCA\uDFCF-\uDFD3\uDFE0-\uDFF0\uDFF4\uDFF8-\uDFFF]|\uD83D[\uDC00-\uDC3E\uDC40\uDC42-\uDCFC\uDCFF-\uDD3D\uDD4B-\uDD4E\uDD50-\uDD67\uDD7A\uDD95\uDD96\uDDA4\uDDFB-\uDE4F\uDE80-\uDEC5\uDECC\uDED0-\uDED2\uDEEB\uDEEC\uDEF4-\uDEF8]|\uD83E[\uDD10-\uDD3A\uDD3C-\uDD3E\uDD40-\uDD45\uDD47-\uDD4C\uDD50-\uDD6B\uDD80-\uDD97\uDDC0\uDDD0-\uDDE6])|(?:[#\*0-9\xA9\xAE\u203C\u2049\u2122\u2139\u2194-\u2199\u21A9\u21AA\u231A\u231B\u2328\u23CF\u23E9-\u23F3\u23F8-\u23FA\u24C2\u25AA\u25AB\u25B6\u25C0\u25FB-\u25FE\u2600-\u2604\u260E\u2611\u2614\u2615\u2618\u261D\u2620\u2622\u2623\u2626\u262A\u262E\u262F\u2638-\u263A\u2640\u2642\u2648-\u2653\u2660\u2663\u2665\u2666\u2668\u267B\u267F\u2692-\u2697\u2699\u269B\u269C\u26A0\u26A1\u26AA\u26AB\u26B0\u26B1\u26BD\u26BE\u26C4\u26C5\u26C8\u26CE\u26CF\u26D1\u26D3\u26D4\u26E9\u26EA\u26F0-\u26F5\u26F7-\u26FA\u26FD\u2702\u2705\u2708-\u270D\u270F\u2712\u2714\u2716\u271D\u2721\u2728\u2733\u2734\u2744\u2747\u274C\u274E\u2753-\u2755\u2757\u2763\u2764\u2795-\u2797\u27A1\u27B0\u27BF\u2934\u2935\u2B05-\u2B07\u2B1B\u2B1C\u2B50\u2B55\u3030\u303D\u3297\u3299]|\uD83C[\uDC04\uDCCF\uDD70\uDD71\uDD7E\uDD7F\uDD8E\uDD91-\uDD9A\uDDE6-\uDDFF\uDE01\uDE02\uDE1A\uDE2F\uDE32-\uDE3A\uDE50\uDE51\uDF00-\uDF21\uDF24-\uDF93\uDF96\uDF97\uDF99-\uDF9B\uDF9E-\uDFF0\uDFF3-\uDFF5\uDFF7-\uDFFF]|\uD83D[\uDC00-\uDCFD\uDCFF-\uDD3D\uDD49-\uDD4E\uDD50-\uDD67\uDD6F\uDD70\uDD73-\uDD7A\uDD87\uDD8A-\uDD8D\uDD90\uDD95\uDD96\uDDA4\uDDA5\uDDA8\uDDB1\uDDB2\uDDBC\uDDC2-\uDDC4\uDDD1-\uDDD3\uDDDC-\uDDDE\uDDE1\uDDE3\uDDE8\uDDEF\uDDF3\uDDFA-\uDE4F\uDE80-\uDEC5\uDECB-\uDED2\uDEE0-\uDEE5\uDEE9\uDEEB\uDEEC\uDEF0\uDEF3-\uDEF8]|\uD83E[\uDD10-\uDD3A\uDD3C-\uDD3E\uDD40-\uDD45\uDD47-\uDD4C\uDD50-\uDD6B\uDD80-\uDD97\uDDC0\uDDD0-\uDDE6])\uFE0F)/;
    function getText(e) {
        var type = e.nodeType, result = "";
        if (type === 1 || type === 9 || type === 11) {
            if (typeof e.textContent === "string") return e.textContent;
            else for(e = e.firstChild; e; e = e.nextSibling)result += getText(e);
        } else if (type === 3 || type === 4) return e.nodeValue;
        return result;
    }
    /*!
	 * SplitText: 3.9.1
	 * https://greensock.com
	 *
	 * @license Copyright 2008-2021, GreenSock. All rights reserved.
	 * Subject to the terms at https://greensock.com/standard-license or for
	 * Club GreenSock members, the agreement issued with that membership.
	 * @author: Jack Doyle, jack@greensock.com
	*/ var _doc, _win, _coreInitted, _stripExp = /(?:\r|\n|\t\t)/g, _multipleSpacesExp = /(?:\s\s+)/g, _initCore = function _initCore() {
        _doc = document;
        _win = window;
        _coreInitted = 1;
    }, _getComputedStyle = function _getComputedStyle(element) {
        return _win.getComputedStyle(element);
    }, _isArray = Array.isArray, _slice = [].slice, _toArray = function _toArray(value, leaveStrings) {
        var type;
        return _isArray(value) ? value : (type = typeof value) === "string" && !leaveStrings && value ? _slice.call(_doc.querySelectorAll(value), 0) : value && type === "object" && "length" in value ? _slice.call(value, 0) : value ? [
            value
        ] : [];
    }, _isAbsolute = function _isAbsolute(vars) {
        return vars.position === "absolute" || vars.absolute === true;
    }, _findSpecialChars = function _findSpecialChars(text, chars) {
        var i = chars.length, s;
        while(--i > -1){
            s = chars[i];
            if (text.substr(0, s.length) === s) return s.length;
        }
    }, _divStart = " style='position:relative;display:inline-block;'", _cssClassFunc = function _cssClassFunc(cssClass, tag) {
        if (cssClass === void 0) cssClass = "";
        var iterate = ~cssClass.indexOf("++"), num = 1;
        if (iterate) cssClass = cssClass.split("++").join("");
        return function() {
            return "<" + tag + _divStart + (cssClass ? " class='" + cssClass + (iterate ? num++ : "") + "'>" : ">");
        };
    }, _swapText = function _swapText(element, oldText, newText) {
        var type = element.nodeType;
        if (type === 1 || type === 9 || type === 11) for(element = element.firstChild; element; element = element.nextSibling)_swapText(element, oldText, newText);
        else if (type === 3 || type === 4) element.nodeValue = element.nodeValue.split(oldText).join(newText);
    }, _pushReversed = function _pushReversed(a, merge) {
        var i = merge.length;
        while(--i > -1)a.push(merge[i]);
    }, _isBeforeWordDelimiter = function _isBeforeWordDelimiter(e, root, wordDelimiter) {
        var next;
        while(e && e !== root){
            next = e._next || e.nextSibling;
            if (next) return next.textContent.charAt(0) === wordDelimiter;
            e = e.parentNode || e._parent;
        }
    }, _deWordify = function _deWordify(e) {
        var children = _toArray(e.childNodes), l = children.length, i, child;
        for(i = 0; i < l; i++){
            child = children[i];
            if (child._isSplit) _deWordify(child);
            else {
                if (i && child.previousSibling && child.previousSibling.nodeType === 3) {
                    child.previousSibling.nodeValue += child.nodeType === 3 ? child.nodeValue : child.firstChild.nodeValue;
                    e.removeChild(child);
                } else if (child.nodeType !== 3) {
                    e.insertBefore(child.firstChild, child);
                    e.removeChild(child);
                }
            }
        }
    }, _getStyleAsNumber = function _getStyleAsNumber(name, computedStyle) {
        return parseFloat(computedStyle[name]) || 0;
    }, _setPositionsAfterSplit = function _setPositionsAfterSplit(element, vars, allChars, allWords, allLines, origWidth, origHeight) {
        var cs = _getComputedStyle(element), paddingLeft = _getStyleAsNumber("paddingLeft", cs), lineOffsetY = -999, borderTopAndBottom = _getStyleAsNumber("borderBottomWidth", cs) + _getStyleAsNumber("borderTopWidth", cs), borderLeftAndRight = _getStyleAsNumber("borderLeftWidth", cs) + _getStyleAsNumber("borderRightWidth", cs), padTopAndBottom = _getStyleAsNumber("paddingTop", cs) + _getStyleAsNumber("paddingBottom", cs), padLeftAndRight = _getStyleAsNumber("paddingLeft", cs) + _getStyleAsNumber("paddingRight", cs), lineThreshold = _getStyleAsNumber("fontSize", cs) * (vars.lineThreshold || 0.2), textAlign = cs.textAlign, charArray = [], wordArray = [], lineArray = [], wordDelimiter = vars.wordDelimiter || " ", tag = vars.tag ? vars.tag : vars.span ? "span" : "div", types = vars.type || vars.split || "chars,words,lines", lines = allLines && ~types.indexOf("lines") ? [] : null, words = ~types.indexOf("words"), chars = ~types.indexOf("chars"), absolute = _isAbsolute(vars), linesClass = vars.linesClass, iterateLine = ~(linesClass || "").indexOf("++"), spaceNodesToRemove = [], isFlex = cs.display === "flex", prevInlineDisplay = element.style.display, i, j, l, node, nodes, isChild, curLine, addWordSpaces, style, lineNode, lineWidth, offset;
        iterateLine && (linesClass = linesClass.split("++").join(""));
        isFlex && (element.style.display = "block");
        j = element.getElementsByTagName("*");
        l = j.length;
        nodes = [];
        for(i = 0; i < l; i++)nodes[i] = j[i];
        if (lines || absolute) for(i = 0; i < l; i++){
            node = nodes[i];
            isChild = node.parentNode === element;
            if (isChild || absolute || chars && !words) {
                offset = node.offsetTop;
                if (lines && isChild && Math.abs(offset - lineOffsetY) > lineThreshold && (node.nodeName !== "BR" || i === 0)) {
                    curLine = [];
                    lines.push(curLine);
                    lineOffsetY = offset;
                }
                if (absolute) {
                    node._x = node.offsetLeft;
                    node._y = offset;
                    node._w = node.offsetWidth;
                    node._h = node.offsetHeight;
                }
                if (lines) {
                    if (node._isSplit && isChild || !chars && isChild || words && isChild || !words && node.parentNode.parentNode === element && !node.parentNode._isSplit) {
                        curLine.push(node);
                        node._x -= paddingLeft;
                        if (_isBeforeWordDelimiter(node, element, wordDelimiter)) node._wordEnd = true;
                    }
                    if (node.nodeName === "BR" && (node.nextSibling && node.nextSibling.nodeName === "BR" || i === 0)) lines.push([]);
                }
            }
        }
        for(i = 0; i < l; i++){
            node = nodes[i];
            isChild = node.parentNode === element;
            if (node.nodeName === "BR") {
                if (lines || absolute) {
                    node.parentNode && node.parentNode.removeChild(node);
                    nodes.splice(i--, 1);
                    l--;
                } else if (!words) element.appendChild(node);
                continue;
            }
            if (absolute) {
                style = node.style;
                if (!words && !isChild) {
                    node._x += node.parentNode._x;
                    node._y += node.parentNode._y;
                }
                style.left = node._x + "px";
                style.top = node._y + "px";
                style.position = "absolute";
                style.display = "block";
                style.width = node._w + 1 + "px";
                style.height = node._h + "px";
            }
            if (!words && chars) {
                if (node._isSplit) {
                    node._next = j = node.nextSibling;
                    node.parentNode.appendChild(node);
                    while(j && j.nodeType === 3 && j.textContent === " "){
                        node._next = j.nextSibling;
                        node.parentNode.appendChild(j);
                        j = j.nextSibling;
                    }
                } else if (node.parentNode._isSplit) {
                    node._parent = node.parentNode;
                    if (!node.previousSibling && node.firstChild) node.firstChild._isFirst = true;
                    if (node.nextSibling && node.nextSibling.textContent === " " && !node.nextSibling.nextSibling) spaceNodesToRemove.push(node.nextSibling);
                    node._next = node.nextSibling && node.nextSibling._isFirst ? null : node.nextSibling;
                    node.parentNode.removeChild(node);
                    nodes.splice(i--, 1);
                    l--;
                } else if (!isChild) {
                    offset = !node.nextSibling && _isBeforeWordDelimiter(node.parentNode, element, wordDelimiter);
                    node.parentNode._parent && node.parentNode._parent.appendChild(node);
                    offset && node.parentNode.appendChild(_doc.createTextNode(" "));
                    if (tag === "span") node.style.display = "inline";
                    charArray.push(node);
                }
            } else if (node.parentNode._isSplit && !node._isSplit && node.innerHTML !== "") wordArray.push(node);
            else if (chars && !node._isSplit) {
                if (tag === "span") node.style.display = "inline";
                charArray.push(node);
            }
        }
        i = spaceNodesToRemove.length;
        while(--i > -1)spaceNodesToRemove[i].parentNode.removeChild(spaceNodesToRemove[i]);
        if (lines) {
            if (absolute) {
                lineNode = _doc.createElement(tag);
                element.appendChild(lineNode);
                lineWidth = lineNode.offsetWidth + "px";
                offset = lineNode.offsetParent === element ? 0 : element.offsetLeft;
                element.removeChild(lineNode);
            }
            style = element.style.cssText;
            element.style.cssText = "display:none;";
            while(element.firstChild)element.removeChild(element.firstChild);
            addWordSpaces = wordDelimiter === " " && (!absolute || !words && !chars);
            for(i = 0; i < lines.length; i++){
                curLine = lines[i];
                lineNode = _doc.createElement(tag);
                lineNode.style.cssText = "display:block;text-align:" + textAlign + ";position:" + (absolute ? "absolute;" : "relative;");
                if (linesClass) lineNode.className = linesClass + (iterateLine ? i + 1 : "");
                lineArray.push(lineNode);
                l = curLine.length;
                for(j = 0; j < l; j++)if (curLine[j].nodeName !== "BR") {
                    node = curLine[j];
                    lineNode.appendChild(node);
                    addWordSpaces && node._wordEnd && lineNode.appendChild(_doc.createTextNode(" "));
                    if (absolute) {
                        if (j === 0) {
                            lineNode.style.top = node._y + "px";
                            lineNode.style.left = paddingLeft + offset + "px";
                        }
                        node.style.top = "0px";
                        if (offset) node.style.left = node._x - offset + "px";
                    }
                }
                if (l === 0) lineNode.innerHTML = "&nbsp;";
                else if (!words && !chars) {
                    _deWordify(lineNode);
                    _swapText(lineNode, String.fromCharCode(160), " ");
                }
                if (absolute) {
                    lineNode.style.width = lineWidth;
                    lineNode.style.height = node._h + "px";
                }
                element.appendChild(lineNode);
            }
            element.style.cssText = style;
        }
        if (absolute) {
            if (origHeight > element.clientHeight) {
                element.style.height = origHeight - padTopAndBottom + "px";
                if (element.clientHeight < origHeight) element.style.height = origHeight + borderTopAndBottom + "px";
            }
            if (origWidth > element.clientWidth) {
                element.style.width = origWidth - padLeftAndRight + "px";
                if (element.clientWidth < origWidth) element.style.width = origWidth + borderLeftAndRight + "px";
            }
        }
        isFlex && (prevInlineDisplay ? element.style.display = prevInlineDisplay : element.style.removeProperty("display"));
        _pushReversed(allChars, charArray);
        words && _pushReversed(allWords, wordArray);
        _pushReversed(allLines, lineArray);
    }, _splitRawText = function _splitRawText(element, vars, wordStart, charStart) {
        var tag = vars.tag ? vars.tag : vars.span ? "span" : "div", types = vars.type || vars.split || "chars,words,lines", chars = ~types.indexOf("chars"), absolute = _isAbsolute(vars), wordDelimiter = vars.wordDelimiter || " ", space = wordDelimiter !== " " ? "" : absolute ? "&#173; " : " ", wordEnd = "</" + tag + ">", wordIsOpen = 1, specialChars = vars.specialChars ? typeof vars.specialChars === "function" ? vars.specialChars : _findSpecialChars : null, text, splitText, i, j, l, character, hasTagStart, testResult, container = _doc.createElement("div"), parent = element.parentNode;
        parent.insertBefore(container, element);
        container.textContent = element.nodeValue;
        parent.removeChild(element);
        element = container;
        text = getText(element);
        hasTagStart = text.indexOf("<") !== -1;
        if (vars.reduceWhiteSpace !== false) text = text.replace(_multipleSpacesExp, " ").replace(_stripExp, "");
        if (hasTagStart) text = text.split("<").join("{{LT}}");
        l = text.length;
        splitText = (text.charAt(0) === " " ? space : "") + wordStart();
        for(i = 0; i < l; i++){
            character = text.charAt(i);
            if (specialChars && (testResult = specialChars(text.substr(i), vars.specialChars))) {
                character = text.substr(i, testResult || 1);
                splitText += chars && character !== " " ? charStart() + character + "</" + tag + ">" : character;
                i += testResult - 1;
            } else if (character === wordDelimiter && text.charAt(i - 1) !== wordDelimiter && i) {
                splitText += wordIsOpen ? wordEnd : "";
                wordIsOpen = 0;
                while(text.charAt(i + 1) === wordDelimiter){
                    splitText += space;
                    i++;
                }
                if (i === l - 1) splitText += space;
                else if (text.charAt(i + 1) !== ")") {
                    splitText += space + wordStart();
                    wordIsOpen = 1;
                }
            } else if (character === "{" && text.substr(i, 6) === "{{LT}}") {
                splitText += chars ? charStart() + "{{LT}}" + "</" + tag + ">" : "{{LT}}";
                i += 5;
            } else if (character.charCodeAt(0) >= 0xD800 && character.charCodeAt(0) <= 0xDBFF || text.charCodeAt(i + 1) >= 0xFE00 && text.charCodeAt(i + 1) <= 0xFE0F) {
                j = ((text.substr(i, 12).split(emojiExp) || [])[1] || "").length || 2;
                splitText += chars && character !== " " ? charStart() + text.substr(i, j) + "</" + tag + ">" : text.substr(i, j);
                i += j - 1;
            } else splitText += chars && character !== " " ? charStart() + character + "</" + tag + ">" : character;
        }
        element.outerHTML = splitText + (wordIsOpen ? wordEnd : "");
        hasTagStart && _swapText(parent, "{{LT}}", "<");
    }, _split = function _split(element, vars, wordStart, charStart) {
        var children = _toArray(element.childNodes), l = children.length, absolute = _isAbsolute(vars), i, child;
        if (element.nodeType !== 3 || l > 1) {
            vars.absolute = false;
            for(i = 0; i < l; i++){
                child = children[i];
                child._next = child._isFirst = child._parent = child._wordEnd = null;
                if (child.nodeType !== 3 || /\S+/.test(child.nodeValue)) {
                    if (absolute && child.nodeType !== 3 && _getComputedStyle(child).display === "inline") {
                        child.style.display = "inline-block";
                        child.style.position = "relative";
                    }
                    child._isSplit = true;
                    _split(child, vars, wordStart, charStart);
                }
            }
            vars.absolute = absolute;
            element._isSplit = true;
            return;
        }
        _splitRawText(element, vars, wordStart, charStart);
    };
    var SplitText = function() {
        function SplitText(element, vars) {
            _coreInitted || _initCore();
            this.elements = _toArray(element);
            this.chars = [];
            this.words = [];
            this.lines = [];
            this._originals = [];
            this.vars = vars || {};
            this.split(vars);
        }
        var _proto = SplitText.prototype;
        _proto.split = function split(vars) {
            this.isSplit && this.revert();
            this.vars = vars = vars || this.vars;
            this._originals.length = this.chars.length = this.words.length = this.lines.length = 0;
            var i = this.elements.length, tag = vars.tag ? vars.tag : vars.span ? "span" : "div", wordStart = _cssClassFunc(vars.wordsClass, tag), charStart = _cssClassFunc(vars.charsClass, tag), origHeight, origWidth, e;
            while(--i > -1){
                e = this.elements[i];
                this._originals[i] = e.innerHTML;
                origHeight = e.clientHeight;
                origWidth = e.clientWidth;
                _split(e, vars, wordStart, charStart);
                _setPositionsAfterSplit(e, vars, this.chars, this.words, this.lines, origWidth, origHeight);
            }
            this.chars.reverse();
            this.words.reverse();
            this.lines.reverse();
            this.isSplit = true;
            return this;
        };
        _proto.revert = function revert() {
            var originals = this._originals;
            if (!originals) throw "revert() call wasn't scoped properly.";
            this.elements.forEach(function(e, i) {
                return e.innerHTML = originals[i];
            });
            this.chars = [];
            this.words = [];
            this.lines = [];
            this.isSplit = false;
            return this;
        };
        SplitText.create = function create(element, vars) {
            return new SplitText(element, vars);
        };
        return SplitText;
    }();
    SplitText.version = "3.9.1";
    exports1.SplitText = SplitText;
    exports1.default = SplitText;
    Object.defineProperty(exports1, "__esModule", {
        value: true
    });
});

},{}],"7XlT4":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _index = require("../../helper/index");
var _success = require("../../api/success");
var _planDataJson = require("../../../../plan-data.json");
var _planDataJsonDefault = parcelHelpers.interopDefault(_planDataJson);
const payment_success = {
    namespace: "payment_success",
    afterEnter (data) {
        console.log(`enter ${this.namespace}`);
        let successWrapClone = $(".success-wrap").clone();
        // gsap.set(successWrapClone, { autoAlpha: 0, y: 10 });
        $(".success-wrap").remove();
        let params = new URL(document.location).searchParams;
        let session_id = params.get("session_id");
        let payment_id = params.get("payment_id");
        let successSelector = (0, _index.selector)(successWrapClone);
        const successFormResult = async ()=>{
            let data_payment_result = await (0, _success.getPaymentResult)(session_id);
            let totalPrice = (data_payment_result.amount_total / 100).toLocaleString();
            successSelector("[data-payment-price]").text(totalPrice);
            let options = {
                day: "numeric",
                month: "short",
                year: "numeric"
            };
            let expiresAt = new Date(data_payment_result.expires_at * 1000).toLocaleDateString("en-GB", options).replace(/(\d{2}) (\w{3})/, "$1 $2,");
            successSelector("[data-payment-expires]").text(expiresAt);
            successSelector("[data-payment-plan]").text((0, _planDataJsonDefault.default)[payment_id].name.split(" ").at(0));
            successSelector("[data-payment-periodic]").text(`/${(0, _planDataJsonDefault.default)[payment_id].name.split(" ").at(-1).toLowerCase()}`);
            successSelector("[data-payment-scope]").text((0, _planDataJsonDefault.default)[payment_id].scope);
        };
        const showSuccessForm = ()=>{
            let tl = gsap.timeline();
            $(".main.success").append(successWrapClone);
            tl.from(".success-bg", {
                autoAlpha: 0.5,
                duration: 2
            }).from(successSelector(".success-popup"), {
                autoAlpha: 0,
                y: 15,
                ease: "power1.out",
                duration: 1
            }, 0).from(successSelector(".success-thanks"), {
                autoAlpha: 0,
                y: 15,
                ease: "power1.out",
                duration: .8
            }, ">=-0.6").from(successSelector(".success-back"), {
                autoAlpha: 0,
                y: 15,
                ease: "power1.out",
                duration: .8
            }, ">=-0.6").from(successSelector(".success-contact"), {
                autoAlpha: 0,
                ease: "power1.out",
                duration: 1
            }, ">=-0.5");
        };
        async function successMain() {
            await successFormResult();
            await showSuccessForm();
        }
        successMain();
    },
    beforeLeave (data) {
        console.log(`leave ${this.namespace}`);
    }
};
exports.default = payment_success;

},{"../../helper/index":"9hx9E","../../api/success":"7NyRs","../../../../plan-data.json":"BTR1D","@parcel/transformer-js/src/esmodule-helpers.js":"81AKE"}],"7NyRs":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getPaymentResult", ()=>getPaymentResult);
parcelHelpers.export(exports, "getPaymentDetail", ()=>getPaymentDetail);
const ApiCall = async ({ url, path, method = "GET", data = {}, token, router, contentType = null, headers = {}, ...params })=>{
    let api;
    let options = {
        method: method,
        headers: {
            ...headers
        },
        ...params
    };
    try {
        api = await fetch(`http://localhost:4000/${path}`, options);
    } catch (e) {
        api = e.response;
    }
    if (api.ok) return api.json();
    else return api.json().then((json)=>Promise.reject(json));
    return api;
};
const getPaymentResult = async (id)=>{
    let { data } = await ApiCall({
        path: "get-payment",
        method: "POST",
        headers: {
            "Content-Type": "application/json"
        },
        body: JSON.stringify({
            session: [
                {
                    id: id
                }
            ]
        })
    });
    return data;
};
const getPaymentDetail = async (id)=>{
    console.log(id);
    let { data } = await ApiCall({
        path: "get-payment-detail",
        method: "POST",
        headers: {
            "Content-Type": "application/json"
        },
        body: JSON.stringify({
            payment: [
                {
                    id: id
                }
            ]
        })
    });
    return data;
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"81AKE"}],"d5rvS":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
const term = {
    namespace: "term",
    afterEnter (data) {
        console.log(`enter ${this.namespace}`);
    },
    beforeLeave (data) {
        console.log(`enter ${this.namespace}`);
    }
};
exports.default = term;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"81AKE"}],"5W8o4":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _header = require("./header");
var _headerDefault = parcelHelpers.interopDefault(_header);
var _footer = require("./footer");
var _footerDefault = parcelHelpers.interopDefault(_footer);
var _popup = require("./popup");
var _popupDefault = parcelHelpers.interopDefault(_popup);
var _magicMouse = require("./magic-mouse");
var _magicMouseDefault = parcelHelpers.interopDefault(_magicMouse);
var _lenis = require("./lenis");
var _button = require("./button");
var _buttonDefault = parcelHelpers.interopDefault(_button);
var _refresh = require("./refresh");
var _refreshDefault = parcelHelpers.interopDefault(_refresh);
const initGlobal = ()=>{
    (0, _lenis.initLenis)();
    if ($(window).width() > 991) (0, _magicMouseDefault.default)();
    (0, _refreshDefault.default)();
    (0, _popupDefault.default)();
    (0, _buttonDefault.default)();
    (0, _headerDefault.default)();
    (0, _footerDefault.default)();
};
exports.default = initGlobal;

},{"./header":"fqJgR","./footer":"1YZ8O","./popup":"l0Kxg","./magic-mouse":"4BIGp","./lenis":"Er3Ar","./button":"7S7c4","./refresh":"bFfJZ","@parcel/transformer-js/src/esmodule-helpers.js":"81AKE"}],"fqJgR":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _index = require("../helper/index");
var _lenis = require("../global/lenis");
var _viewport = require("../helper/viewport");
var _splitText = require("../libs/SplitText");
const setupDot = ()=>{
    let allSections = $("[data-section]");
    let tempLabel = $(".header-menu-label-item").eq(0).clone();
    let tempProg = $(".header-menu-prog-item-wrap").eq(0).clone();
    $(".header-menu-label").find(".header-menu-label-item").remove();
    $(".header-menu-prog").find(".header-menu-prog-item-wrap").remove();
    allSections.each((idx, el)=>{
        let htmlLabel = tempLabel.clone();
        htmlLabel.attr("data-header-id", `${$(el).attr("data-section-id")}`);
        htmlLabel.find("span").text(`${$(el).attr("data-section-id")}`);
        $(".header-menu-label").append(htmlLabel);
        let htmlProg = tempProg.clone();
        htmlProg.attr("href", `#${$(el).attr("data-section-id")}`);
        htmlProg.attr("data-header-id", `${$(el).attr("data-section-id")}`);
        $(".header-menu-prog").append(htmlProg);
    });
};
const updateProgressByScroll = ()=>{
    let allSections = $("[data-section]");
    const DOM = {
        labelItem: $(".header-menu-label-item"),
        labelById: (id)=>$(`.header-menu-label-item[data-header-id="${id}"]`),
        labelSMById: (id)=>$(`.header-menu-sm-list [data-header-id="${id}"]`),
        progWrap: $(`.header-menu-prog-item-wrap`),
        progItem: $(`.header-menu-prog-item`),
        progById: (id)=>$(`.header-menu-prog-item-wrap[data-header-id="${id}"]`)
    };
    setTimeout(()=>{
        let offset = "40%";
        allSections.each((idx, el)=>{
            ScrollTrigger.create({
                trigger: el,
                start: `top top+=${offset}`,
                end: `bottom bottom-=${offset}`,
                scrub: true,
                onUpdate: (self)=>{
                    let currSection = allSections.eq(idx);
                    let id = currSection.attr("data-section-id");
                    if ($(window).width() > 767) {
                        DOM.labelById(id).addClass("active");
                        DOM.labelItem.not(DOM.labelById(id)).removeClass("active");
                        DOM.progById(id).addClass("active");
                        DOM.progWrap.not(DOM.progById(id)).removeClass("active");
                        DOM.progById(id).find(DOM.progItem).addClass("active");
                        DOM.progWrap.not(DOM.progById(id)).find(DOM.progItem).removeClass("active");
                        let percent = Math.ceil(self.progress * 100 - 100);
                        gsap.to(DOM.progById(id).find(".header-menu-prog-item-inner"), {
                            xPercent: percent,
                            duration: .3,
                            overwrite: true
                        });
                    } else {
                        $(".header-menu-sm-list a").removeClass("active");
                        DOM.labelSMById(id).addClass("active");
                        gsap.set(".header-menu-sm-process-inner-line", {
                            top: `${idx * ($(".header-menu-sm-process-inner").height() - $(".header-menu-sm-process-inner-line").height()) / (allSections.length - 1) / $(".header-menu-sm-process-inner").height() * 100}%`
                        });
                    }
                }
            });
        });
        ScrollTrigger.create({
            trigger: ".home-main",
            start: `top top+=${offset}`,
            end: `bottom bottom-=${offset}`,
            onLeave: ()=>{
                $(`.header-menu-label-item`).removeClass("active");
                $(`.header-menu-prog-item`).removeClass("active");
            },
            onLeaveBack: ()=>{
                $(`.header-menu-label-item`).removeClass("active");
                $(`.header-menu-prog-item`).removeClass("active");
            }
        });
    }, 100);
    $(".header-main [data-header-id]").on("click", function(e) {
        let target = $(this).attr("data-header-id");
        if ($("html").hasClass("lenis-smooth")) (0, _lenis.lenis).scrollTo(`[data-section-id="${target}"]`);
        else {
            let targetTop = $(`[data-section-id="${target}"]`).get(0).offsetTop + $(window).height();
            $("html").animate({
                scrollTop: targetTop
            });
        }
        history.replaceState({}, "", `${window.location.pathname}#${target}`);
        return false;
    });
    const checkMenuActive = ()=>{
        if ($(".header-menu-label").length) {
            if ($(".header-menu-label-item.active").length === 0) gsap.set(".header-menu-label", {
                "--d-width": "0px"
            });
            else gsap.set(".header-menu-label", {
                "--d-width": `${$(".header-menu-label-item.active").eq(0).width()}px`
            });
            requestAnimationFrame(checkMenuActive);
        }
    };
    requestAnimationFrame(checkMenuActive);
};
const hoverDot = ()=>{
    $(".header-menu-prog-item-wrap").on("mouseenter", function(e) {
        let content = $(this).attr("data-header-id");
        $(".header-menu-prog-label").text(content);
        gsap.to(".header-menu-prog-label", {
            autoAlpha: 1
        });
    });
    $(".header-menu-prog-item-wrap").on("mouseleave", function(e) {
        gsap.to(".header-menu-prog-label", {
            autoAlpha: 0
        });
    });
};
function checkHoverDot() {
    if ($(".header-menu-prog-item-wrap:hover").length) {
        let target = $(".header-menu-prog-item-wrap:hover");
        let currX = (0, _index.xGetter)(".header-menu-prog-label");
        (0, _index.xSetter)(".header-menu-prog-label")((0, _index.lerp)(currX, target.get(0).offsetLeft - $(".header-menu-prog-label").outerWidth() / 2 + target.outerWidth() / 2));
    }
    requestAnimationFrame(checkHoverDot);
}
const updateHeaderBarByScroll = ()=>{
    if ($(".home-main").length) {
        let offsetHeaderMain = $(".header-main").offset().left;
        let tlHeaderTrigger = gsap.timeline({
            scrollTrigger: {
                trigger: ".home-main",
                start: `top+=${$(".header").outerHeight()} top`,
                onEnter: ()=>{
                    $(".header-logo").addClass("active");
                    if ($(window).width() > 767) {
                        $(".header-menu").addClass("active");
                        $(".header-hamburger").addClass("active");
                        if ($(window).width() <= 991) {
                            gsap.to(".header-main-schedule", {
                                width: 0,
                                overwrite: true
                            });
                            gsap.to(".header-hamburger", {
                                width: 0,
                                overwrite: true
                            });
                            gsap.to(".header-menu-label", {
                                marginLeft: "1rem"
                            });
                        }
                    }
                    if ($(window).width() <= 767) {
                        gsap.to(".header-main", {
                            marginRight: 0
                        });
                        gsap.to(".header-hamburger", {
                            width: (0, _viewport.cvUnit)(60, "rem"),
                            overwrite: true
                        });
                        gsap.to(".header-logo", {
                            width: "auto",
                            marginRight: (0, _viewport.cvUnit)(32, "rem")
                        });
                    }
                },
                onLeaveBack: ()=>{
                    $(".header-logo").removeClass("active");
                    $(".header-hamburger").removeClass("active");
                    $(".header-menu-sm").slideUp(400);
                    if ($(window).width() > 767) $(".header-menu").removeClass("active");
                    if ($(window).width() <= 991) {
                        gsap.to(".header-main-schedule", {
                            width: "auto",
                            overwrite: true
                        });
                        gsap.to(".header-hamburger", {
                            width: (0, _viewport.cvUnit)(60, "rem"),
                            overwrite: true
                        });
                        gsap.to(".header-menu-label", {
                            marginLeft: "0"
                        });
                    }
                    if ($(window).width() <= 767) {
                        gsap.to(".header-main", {
                            marginRight: offsetHeaderMain
                        });
                        gsap.to(".header-hamburger", {
                            width: 0,
                            overwrite: true
                        });
                        gsap.to(".header-logo", {
                            width: 0,
                            marginRight: 0
                        });
                    }
                }
            }
        });
    }
    $(".header-menu-sm").slideUp(50);
    $(".header-hamburger").on("click", function(e) {
        e.preventDefault();
        if (!$(this).hasClass("active")) {
            if ($(window).width() > 767) {
                $(".header-menu").addClass("active");
                if ($(window).width() <= 991) gsap.to(".header-menu-label", {
                    marginLeft: "1rem"
                });
            } else {
                $(".header-menu-sm").slideDown(400);
                gsap.set(".header-menu-sm-process-inner-line", {
                    top: `${$("[data-section]").length / 2 * ($(".header-menu-sm-process-inner").height() - $(".header-menu-sm-process-inner-line").height()) / ($("[data-section]").length - 1) / $(".header-menu-sm-process-inner").height() * 100}%`
                });
            }
            $(this).addClass("active");
        } else {
            if ($(window).width() > 767) {
                $(".header-menu").removeClass("active");
                if ($(window).width() <= 991) gsap.to(".header-menu-label", {
                    marginLeft: "0"
                });
            } else $(".header-menu-sm").slideUp(400);
            $(this).removeClass("active");
        }
    });
    if ($(window).width() <= 767) $("html").on("click", function(e) {
        if (!$(".header:hover").length) {
            $(".header-menu").removeClass("active");
            $(".header-menu-sm").slideUp(400);
            $(".header-hamburger").removeClass("active");
        }
    });
};
const header = {
    setup () {
        setupDot();
    },
    init () {
        updateProgressByScroll();
        updateHeaderBarByScroll();
        if ($(window).width() > 991) {
            hoverDot();
            checkHoverDot();
        }
    }
};
const initHeader = ()=>{
    header.setup();
    header.init();
};
exports.default = initHeader;

},{"../helper/index":"9hx9E","../global/lenis":"Er3Ar","../helper/viewport":"1S9hW","../libs/SplitText":"g3xEb","@parcel/transformer-js/src/esmodule-helpers.js":"81AKE"}],"1YZ8O":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _index = require("../helper/index");
var _marquee = require("../common/marquee");
var _lenis = require("./lenis");
var _viewport = require("../helper/viewport");
const initFooter = ()=>{
    (0, _marquee.marqueeCSS)({
        parent: (0, _index.selector)(".footer-brands"),
        duration: 10
    });
    const curtainFooter = ()=>{
        let curtainHeight = $(".footer-curtain").height();
        gsap.from(".footer-curtain--inner", {
            scrollTrigger: {
                trigger: ".footer-curtain",
                start: "top bottom",
                endTrigger: ".footer",
                end: `bottom bottom+=${(0, _viewport.cvUnit)((0, _viewport.viewportBreak)({
                    desktop: 0,
                    tablet: -40,
                    mobile: -90
                }), "rem") - curtainHeight}`,
                scrub: .2
            },
            scaleY: 0,
            stagger: {
                amount: -0.35
            },
            delay: .2,
            ease: "power1.inOut"
        });
    };
    curtainFooter();
    const parallaxBear = ()=>{
        let target = $(".footer-curtain-logo");
        let tarCurrX = (0, _index.xGetter)(target.get(0));
        let tarCurrY = (0, _index.yGetter)(target.get(0));
        let tarCurrRotz = (0, _index.rotZGetter)(target.get(0));
        if (target.hasClass("active")) {
            let moveX = ((0, _index.pointerCurr)().x / $(window).width() - 0.5) * ($(window).width() - target.width() - (0, _viewport.cvUnit)(60, "rem"));
            let moveY = ((0, _index.pointerCurr)().y / $(window).height() - 0.5) * 2 * (target.height() / 8);
            (0, _index.xSetter)(target.get(0))((0, _index.lerp)(tarCurrX, moveX, .02));
            (0, _index.ySetter)(target.get(0))((0, _index.lerp)(tarCurrY, moveY, .02));
            (0, _index.rotZSetter)(target.get(0))((0, _index.lerp)(tarCurrRotz, Math.min(Math.max((moveX - tarCurrX) / 80, -7), 7), .08));
        } else {
            (0, _index.xSetter)(target.get(0))((0, _index.lerp)(tarCurrX, 0, .02));
            (0, _index.ySetter)(target.get(0))((0, _index.lerp)(tarCurrY, 0, .02));
            (0, _index.rotZSetter)(target.get(0))((0, _index.lerp)(tarCurrRotz, 0, .08));
        }
        requestAnimationFrame(parallaxBear);
    };
    ScrollTrigger.create({
        trigger: ".footer",
        start: "top bottom",
        end: "bottom top",
        toggleClass: {
            targets: ".footer-curtain-logo",
            className: "active"
        },
        onEnter: ()=>{
            if ($(window).width() > 991) parallaxBear();
        }
    });
    $("[data-action='scrollTop']").on("click", function(e) {
        e.preventDefault();
        if (!(0, _viewport.isTouchDevice)()) (0, _lenis.lenis).scrollTo(0);
        else $("html").animate({
            scrollTop: 0
        });
    });
};
exports.default = initFooter;

},{"../helper/index":"9hx9E","../common/marquee":"3g4hE","./lenis":"Er3Ar","../helper/viewport":"1S9hW","@parcel/transformer-js/src/esmodule-helpers.js":"81AKE"}],"3g4hE":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "marqueeGS", ()=>marqueeGS);
parcelHelpers.export(exports, "marqueeCSS", ()=>marqueeCSS);
var _viewport = require("../helper/viewport");
const marqueeGS = (data)=>{
    const { parent, duration, start, stopWhenScroll } = data;
    const direction = {
        right: "-=",
        left: "+="
    };
    const DOM = {
        wrap: parent(".marquee"),
        list: parent(".marquee-inner"),
        item: parent(".marquee-inner-item")
    };
    let isHover = false;
    let tlMarquee = gsap.timeline({
        repeat: -1,
        // onReverseComplete() {
        //     this.totalTime(this.rawTime() + this.duration() * 10);
        // },
        onUpdate: ()=>{
            if (!isHover) {
                let tlDir = lenis.direction >= 0 ? 1 : -1;
                gsap.to(tlMarquee, {
                    timeScale: tlDir * Math.min(Math.max(lenis.velocity / 2, 1), 4),
                    duration: .1,
                    ease: "none"
                });
            }
        }
    });
    ScrollTrigger.create({
        trigger: DOM.wrap,
        start: "top bottom",
        once: true,
        onEnter: ()=>{
            let cloneAmount = 2;
            const cloneAdditional = Math.floor((0, _viewport.viewport).width / DOM.item.width());
            if (cloneAdditional >= 1) cloneAmount += cloneAdditional;
            DOM.item.css({
                position: "relative",
                top: 0,
                left: 0
            });
            gsap.set(DOM.item, {
                x: -1 * DOM.item.eq(0).width()
            });
            new Array(cloneAmount).fill().forEach((_, index)=>{
                let itemClone = DOM.item.clone();
                gsap.set(itemClone, {
                    position: "absolute",
                    top: 0,
                    left: 0,
                    x: index * DOM.item.width(),
                    height: "100%"
                });
                DOM.list.append(itemClone);
            });
            tlMarquee.seek(28800);
            tlMarquee.to(DOM.list, {
                x: direction[start || "left"] + `${DOM.item.eq(0).width()}`,
                duration: DOM.item.eq(0).width() / duration,
                ease: "linear"
            });
        }
    });
    if (stopWhenScroll) {
        DOM.wrap.on("pointerenter", (event)=>{
            isHover = true;
            gsap.to(tlMarquee, {
                timeScale: 0,
                ease: "power1.inOut",
                duration: 0.3,
                overwrite: true
            });
        });
        DOM.wrap.on("pointerleave", (event)=>{
            isHover = false;
            gsap.to(tlMarquee, {
                timeScale: 1,
                ease: "power1.inOut",
                duration: 0.3,
                overwrite: true
            });
        });
    }
    return tlMarquee;
};
const marqueeCSS = (data)=>{
    const { parent, duration, start, delay, stopWhenScroll } = data;
    const direction = {
        right: "reverse",
        left: "normal"
    };
    const DOM = {
        wrap: parent(".marquee"),
        list: parent(".marquee-inner"),
        item: parent(".marquee-inner-item")
    };
    let cloneAmount = 2;
    const cloneAdditional = Math.floor((0, _viewport.viewport).width / DOM.item.width());
    if (cloneAdditional >= 1) cloneAmount += cloneAdditional;
    new Array(cloneAmount).fill().forEach((_, index)=>{
        let itemClone = DOM.item.clone();
        DOM.list.append(itemClone);
    });
    DOM.list.addClass("marquee-anim");
    gsap.set(parent(".marquee-anim"), {
        "--duration": DOM.item.width() / duration || parent(".marquee-anim").css("--duration"),
        "--direction": direction[start] || parent(".marquee-anim").css("--direction"),
        "--delay": delay || parent(".marquee-anim").css("--delay")
    });
    new Array(1).fill().forEach((_, index)=>{
        let itemClone = parent(".marquee-inner").clone();
        DOM.wrap.append(itemClone);
    });
};

},{"../helper/viewport":"1S9hW","@parcel/transformer-js/src/esmodule-helpers.js":"81AKE"}],"l0Kxg":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _lenis = require("./lenis");
const popup = (name)=>{
    let popupWrap = $(`[data-popup-${name}='wrap']`);
    const popupAction = {
        open: (el)=>{
            popupWrap.addClass("active");
            requestAnimationFrame(()=>$(".header-bar").addClass("force"));
        },
        close: ()=>{
            if (!popupWrap.hasClass("active")) return;
            setTimeout(()=>{
                popupWrap.removeClass("active");
                $(".header-bar").removeClass("force");
            }, 100);
            (0, _lenis.lenis).start();
        },
        update: (target)=>{
            $(".popup--sidebar-content").empty();
            let parent = $(target).closest(".home-benefit-item");
            let title = parent.find(".home-benefit-other-title").text();
            $(".popup--sidebar-header-heading").text(title);
            let cloner;
            parent.find(".home-benefit-other-sub-txt").each((idx, el)=>{
                cloner = $(el).clone();
                cloner.removeAttr("class");
                cloner.removeAttr("style");
                $(".popup--sidebar-content").append(cloner.clone());
            });
        }
    };
    $(`[data-popup-${name}]`).on("click", function(e) {
        if ($(this).attr(`data-popup-${name}`) === "open") {
            e.preventDefault();
            popupAction.open(this);
            popupAction.update(this);
        } else if ($(this).attr(`data-popup-${name}`) === "close") {
            e.preventDefault();
            (0, _lenis.lenis).start();
            popupAction.close();
        } else return;
    });
    $(window).on("click", (e)=>{
        if (!$(`[data-popup-${name}='wrap'] .popup-content>div:hover`).length) {
            if (!$(`[data-popup-${name}='open']:hover`).length) popupAction.close();
        }
    });
};
const initPopup = ()=>{
    popup("benefit");
};
exports.default = initPopup;

},{"./lenis":"Er3Ar","@parcel/transformer-js/src/esmodule-helpers.js":"81AKE"}],"4BIGp":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _index = require("../helper/index");
var _viewport = require("../helper/viewport");
const initCursor = ()=>{
    let cursorChange = false;
    let insideBgSc = false;
    const velChange = .12;
    let cursor = $(".cursor");
    let targetPos;
    let forcing = false;
    function initMouseMove() {
        let cursorX = (0, _index.xGetter)(cursor.get(0));
        let cursorY = (0, _index.yGetter)(cursor.get(0));
        let zRot = (0, _index.rotZGetter)(cursor.get(0));
        let scaleX = (0, _index.scaleXGetter)(cursor.get(0));
        let scaleY = (0, _index.scaleYGetter)(cursor.get(0));
        let dotX = (0, _index.xGetter)(cursor.find(".cursor-dot").get(0));
        let dotY = (0, _index.yGetter)(cursor.find(".cursor-dot").get(0));
        let borderX = (0, _index.xGetter)(cursor.find(".cursor-border").get(0));
        let borderY = (0, _index.yGetter)(cursor.find(".cursor-border").get(0));
        let glowX = (0, _index.xGetter)(cursor.find(".cursor-glow").get(0));
        let glowY = (0, _index.yGetter)(cursor.find(".cursor-glow").get(0));
        targetPos = {
            x: (0, _index.pointerCurr)().x,
            y: (0, _index.pointerCurr)().y
        };
        function updatePos(mode) {
            if (mode == "force") ;
            else {
                (0, _index.xSetter)(cursor.get(0))((0, _index.lerp)(cursorX, targetPos.x, .1));
                (0, _index.ySetter)(cursor.get(0))((0, _index.lerp)(cursorY, targetPos.y, .1));
            }
            (0, _index.xSetter)(cursor.find(".cursor-border").get(0))((0, _index.lerp)(borderX, -(targetPos.x - cursorX) / 20, .15));
            (0, _index.ySetter)(cursor.find(".cursor-border").get(0))((0, _index.lerp)(borderY, -(targetPos.y - cursorY) / 20, .15));
            (0, _index.xSetter)(cursor.find(".cursor-glow").get(0))((0, _index.lerp)(glowX, -(targetPos.x - cursorX) / 4, .1));
            (0, _index.ySetter)(cursor.find(".cursor-glow").get(0))((0, _index.lerp)(glowY, -(targetPos.y - cursorY) / 4, .1));
        }
        // let scaleOffset = Math.min(Math.sqrt(((pointerCurr().x - cursorX)**2 + (pointerCurr().y - cursorY)**2), 2) / 500, .5)
        // scaleXSetter(cursor.get(0))(lerp(scaleX, 1 + scaleOffset, .15))
        // scaleYSetter(cursor.get(0))(lerp(scaleY, 1 - scaleOffset, .15))
        // rotZSetter(cursor.get(0))((Math.atan2(pointerCurr().y - cursorY, pointerCurr().x - cursorX) * 180) / Math.PI)
        let showreelIc = $(".home-showreel-play-ic");
        let showreelIcX = (0, _index.xGetter)(showreelIc.get(0));
        let showreelIcY = (0, _index.yGetter)(showreelIc.get(0));
        let targetX, targetY;
        if ($(".home-showreel-thumb").length) {
            if ($('[data-video="to-pause"]').length && $(".home-showreel-thumb:hover").length) {
                // targetX = (pointerCurr().x/$(window).width() - .5) * 2 * ($('.home-showreel-thumb').width() - showreelIc.width())/2
                // targetY = ((pointerCurr().y - $('.home-showreel-thumb').get(0).getBoundingClientRect().top)/($('.home-showreel-thumb').height()) - 0.5) * ($('.home-showreel-thumb').height() - showreelIc.width())
                targetX = ((0, _index.pointerCurr)().x / $(window).width() - .5) * 2 * $(window).width() / 2;
                targetY = (((0, _index.pointerCurr)().y - $(".home-showreel-thumb").get(0).getBoundingClientRect().top) / $(".home-showreel-thumb").height() - 0.5) * $(".home-showreel-thumb").height();
                cursor.find(".cursor-dot").addClass("hide");
                cursor.find(".cursor-border").addClass("hide");
                cursor.find(".cursor-glow").addClass("hide");
                if (!showreelIc.hasClass("pause")) {
                    showreelIc.addClass("pause");
                    gsap.to(showreelIc, {
                        scale: .4,
                        autoAlpha: 1,
                        overwrite: true
                    });
                }
            } else {
                targetX = 0;
                targetY = 0;
                showreelIc.removeClass("pause");
                cursor.find(".cursor-dot").removeClass("hide");
                cursor.find(".cursor-border").removeClass("hide");
                cursor.find(".cursor-glow").removeClass("hide");
                gsap.to(showreelIc, {
                    scale: 1,
                    autoAlpha: 1,
                    overwrite: true
                });
            }
        }
        if ($('[data-video="to-pause"]').length && !$(".home-showreel-thumb:hover").length) gsap.to(showreelIc, {
            scale: 1,
            autoAlpha: 0,
            overwrite: true
        });
        (0, _index.xSetter)(showreelIc.get(0))((0, _index.lerp)(showreelIcX, targetX, .1));
        (0, _index.ySetter)(showreelIc.get(0))((0, _index.lerp)(showreelIcY, targetY, .1));
        if ($("[data-cursor]:hover").length) {
            let target = $("[data-cursor]:hover");
            let targetOffsetLeft = target.get(0).getBoundingClientRect().left;
            let targetOffsetTop = target.get(0).getBoundingClientRect().top;
            if (target.find(".txt").length) {
                txtOffsetLeft = target.find(".txt").get(0).getBoundingClientRect().left;
                txtOffsetTop = target.find(".txt").get(0).getBoundingClientRect().top;
            }
            if (target.find("[data-cursor-dotpos]").length) {
                dotOffsetLeft = target.find("[data-cursor-dotpos]").get(0).getBoundingClientRect().left;
                dotOffsetTop = target.find("[data-cursor-dotpos]").get(0).getBoundingClientRect().top;
            }
            let targetValue = {
                w: $("[data-cursor]:hover").outerWidth(),
                h: $("[data-cursor]:hover").outerHeight()
            };
            let type = target.attr("data-cursor");
            switch(type){
                case "stick":
                    cursor.closest(".cursor-wrap").addClass("mixBlendMode");
                    cursor.find(".cursor-dot").addClass("stickstepdot");
                    cursor.find(".cursor-border").addClass("stickstepdot");
                    targetPos = {
                        x: targetOffsetLeft + target.outerWidth() / 2,
                        y: targetOffsetTop + target.outerHeight() / 2
                    };
                    (0, _index.xSetter)(cursor.get(0))((0, _index.lerp)(cursorX, targetOffsetLeft + target.outerWidth() / 2, velChange));
                    (0, _index.ySetter)(cursor.get(0))((0, _index.lerp)(cursorY, targetOffsetTop + target.outerHeight() / 2, velChange));
                    (0, _index.xSetter)(cursor.find(".cursor-border").get(0))((0, _index.lerp)(borderX, 0, velChange));
                    (0, _index.ySetter)(cursor.find(".cursor-border").get(0))((0, _index.lerp)(borderY, 0, velChange));
                    break;
                case "radar":
                    cursor.find(".cursor-dot").addClass("hide");
                    targetPos = {
                        x: targetOffsetLeft + target.outerWidth() / 2,
                        y: targetOffsetTop + target.outerHeight() / 2
                    };
                    updatePos();
                    (0, _index.xSetter)(cursor.find(".cursor-border").get(0))((0, _index.lerp)(borderX, 0, .15));
                    (0, _index.ySetter)(cursor.find(".cursor-border").get(0))((0, _index.lerp)(borderY, 0, .15));
                    break;
                case "hidden":
                    updatePos();
                    gsap.to(cursor.find(".cursor-dot"), {
                        scale: 0,
                        duration: .6,
                        ease: "power2.out",
                        overwrite: true
                    });
                    gsap.to(cursor.find(".cursor-border"), {
                        scale: 1.5,
                        autoAlpha: 0,
                        duration: .4,
                        ease: "power2.out",
                        overwrite: true
                    });
                    gsap.to(cursor.find(".cursor-glow"), {
                        scale: 1.5,
                        autoAlpha: 0,
                        duration: .4,
                        ease: "power2.out",
                        overwrite: true
                    });
                    break;
                case "dotstick":
                    cursor.find(".cursor-dot").addClass("stickfaq");
                    targetPos = {
                        x: dotOffsetLeft + target.find("[data-cursor-dotpos]").outerWidth() / 2,
                        y: dotOffsetTop + target.find("[data-cursor-dotpos]").outerHeight() / 2
                    };
                    updatePos();
                    if (target.hasClass("hovered")) {
                        if (Math.abs(cursorY - targetPos.y) <= 1 || forcing == true) {
                            updatePos("force");
                            forcing = true;
                        }
                    } else {
                        forcing = false;
                        $(`[data-cursor="dotstick"]`).removeClass("hovered");
                        target.addClass("hovered");
                    }
                    break;
                case "txtstick":
                    cursor.find(".cursor-dot").addClass("smdot");
                    cursor.find(".cursor-border").addClass("hide");
                    cursor.find(".cursor-glow").addClass("hide");
                    if (target.hasClass("footer-link")) cursor.find(".cursor-dot").addClass("whitedot");
                    targetPos = {
                        x: targetOffsetLeft + (0, _viewport.cvUnit)(-10, "rem"),
                        y: targetOffsetTop + targetValue.h / 2
                    };
                    updatePos();
                    break;
                case "halostick":
                    cursor.find(".cursor-dot").addClass("smdot");
                    cursor.find(".cursor-border").addClass("hide");
                    cursor.find(".cursor-glow").addClass("hide");
                    gsap.to(target, {
                        x: (0, _viewport.cvUnit)(15, "rem"),
                        duration: .6,
                        ease: "power2.out",
                        overwrite: true
                    });
                    targetPos = {
                        x: targetOffsetLeft + (0, _viewport.cvUnit)(-10, "rem"),
                        y: targetOffsetTop + targetValue.h / 2
                    };
                    updatePos();
                    break;
                case "btnstick":
                    cursor.find(".cursor-dot").removeClass("hide");
                    cursor.find(".cursor-glow").removeClass("hide");
                    cursor.find(".cursor-dot").addClass("smdot");
                    cursor.find(".cursor-border").addClass("hide");
                    gsap.to(target.find(".txt"), {
                        x: (0, _viewport.cvUnit)(15, "rem") / 2,
                        duration: .6,
                        ease: "power2.out",
                        overwrite: true
                    });
                    if (target.hasClass("btn-white")) cursor.find(".cursor-dot").addClass("whitedot");
                    else if (target.hasClass("btn-black")) cursor.find(".cursor-dot").addClass("whitedot");
                    else cursor.find(".cursor-dot").addClass("whitedot");
                    targetPos = {
                        x: txtOffsetLeft + (0, _viewport.cvUnit)(-15, "rem") + parseInt(target.find(".txt").css("paddingLeft")),
                        y: txtOffsetTop + target.height() / 2
                    };
                    updatePos();
                    break;
                case "menuprog":
                    cursor.find(".cursor-dot").removeClass("hide");
                    cursor.find(".cursor-dot").removeClass("whitedot");
                    cursor.find(".cursor-dot").addClass("smdot");
                    cursor.find(".cursor-border").addClass("hide");
                    cursor.find(".cursor-glow").addClass("hide");
                    targetPos = {
                        x: targetOffsetLeft + targetValue.w / 2,
                        y: targetOffsetTop + targetValue.h / 2
                    };
                    updatePos();
                    break;
                case "hamburger":
                    cursor.find(".cursor-dot").removeClass("whitedot");
                    cursor.find(".cursor-border").removeClass("hide");
                    cursor.find(".cursor-dot").addClass("hide");
                    cursor.find(".cursor-border").addClass("mddot");
                    cursor.find(".cursor-glow").addClass("hide");
                    targetPos = {
                        x: targetOffsetLeft + targetValue.w / 2,
                        y: targetOffsetTop + targetValue.h / 2
                    };
                    updatePos();
                    (0, _index.xSetter)(cursor.find(".cursor-border").get(0))((0, _index.lerp)(borderX, 0, velChange));
                    (0, _index.ySetter)(cursor.find(".cursor-border").get(0))((0, _index.lerp)(borderY, 0, velChange));
                    break;
            }
            cursorChange = true;
        } else {
            forcing = false;
            if (cursorChange == true) {
                cursor.closest(".cursor-wrap").removeClass("mixBlendMode");
                gsap.to('[data-cursor="btnstick"] .txt', {
                    x: 0,
                    duration: .6,
                    ease: "power2.out"
                });
                gsap.to('[data-cursor="halostick"]', {
                    x: 0,
                    duration: .6,
                    ease: "power2.out"
                });
                cursor.find(".cursor-dot").removeClass("stickstepdot");
                cursor.find(".cursor-dot").removeClass("hide");
                cursor.find(".cursor-dot").removeClass("smdot");
                cursor.find(".cursor-dot").removeClass("whitedot");
                cursor.find(".cursor-dot").removeClass("blackdot");
                cursor.find(".cursor-dot").removeClass("stickfaq");
                cursor.find(".cursor-border").removeClass("stickstepdot");
                cursor.find(".cursor-border").removeClass("mddot");
                cursor.find(".cursor-border").removeClass("hide");
                cursor.find(".cursor-glow").removeClass("hide");
                cursorChange = false;
            }
            updatePos();
        }
        if ($(".home-portfolio:hover").length || $(".home-pricing-plan-item.popular:hover").length || $(".home-curtain:hover").length) {
            if (insideBgSc == false || cursorChange == false) {
                cursor.find(".cursor-dot").addClass("whitedot");
                insideBgSc = true;
            }
        } else if (insideBgSc == true) {
            cursor.find(".cursor-dot").removeClass("whitedot");
            insideBgSc = false;
        }
        requestAnimationFrame(initMouseMove);
    }
    if ($(window).width() > 991) initMouseMove();
};
exports.default = initCursor;

},{"../helper/index":"9hx9E","../helper/viewport":"1S9hW","@parcel/transformer-js/src/esmodule-helpers.js":"81AKE"}],"7S7c4":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _lenis = require("./lenis");
var _viewport = require("../helper/viewport");
const initButton = ()=>{
    $(".btn").each((_, el)=>{
        let bgOverlay = $("<div></div>").addClass("btnoverlay");
        $(el).append(bgOverlay);
    });
    $("a.btn").each((_, item)=>{
        let href = $(item).attr("href");
        if (href.startsWith("./")) href = href.slice(2);
        $(item).attr("href", `${origin}/${href}`);
    });
    $("a.btn").on("click", function(e) {
        const url = new URL($(this).attr("href"));
        if (url.pathname === window.location.pathname) {
            if (url.hash) {
                e.preventDefault();
                let target = url.hash.replace("#", "");
                if ($("html").hasClass("lenis-smooth")) (0, _lenis.lenis).scrollTo(`[id="${target}"]`);
                else {
                    let targetTop = $(`[id="${target}"]`).get(0).offsetTop + $(window).height();
                    $("html").animate({
                        scrollTop: targetTop
                    });
                }
                history.replaceState({}, "", `${window.location.pathname}${url.hash}`);
                return false;
            }
        }
    });
};
exports.default = initButton;

},{"./lenis":"Er3Ar","../helper/viewport":"1S9hW","@parcel/transformer-js/src/esmodule-helpers.js":"81AKE"}],"bFfJZ":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _index = require("../helper/index");
const refreshOnBreakpoint = ()=>{
    let initialViewportWidth = window.innerWidth || document.documentElement.clientWidth;
    let newViewportWidth;
    // portrait mobile viewport initial, any change refresh
    if (initialViewportWidth < 480) $(window).on("resize", (0, _index.debounce)(function() {
        newViewportWidth = window.innerWidth || document.documentElement.clientWidth;
        if (newViewportWidth > 479) location.reload();
    }));
    else if (initialViewportWidth < 768) $(window).on("resize", (0, _index.debounce)(function() {
        newViewportWidth = window.innerWidth || document.documentElement.clientWidth;
        if (newViewportWidth > 767) location.reload();
    }));
    else if (initialViewportWidth > 767 && initialViewportWidth < 992) $(window).on("resize", (0, _index.debounce)(function() {
        newViewportWidth = window.innerWidth || document.documentElement.clientWidth;
        if (newViewportWidth < 768 || newViewportWidth > 991) location.reload();
    }));
    else if (initialViewportWidth > 991) $(window).on("resize", (0, _index.debounce)(function() {
        newViewportWidth = window.innerWidth || document.documentElement.clientWidth;
        if (newViewportWidth < 992) location.reload();
    }));
};
exports.default = refreshOnBreakpoint;

},{"../helper/index":"9hx9E","@parcel/transformer-js/src/esmodule-helpers.js":"81AKE"}]},["i56Ye"], "i56Ye", "parcelRequirea9a6")

//# sourceMappingURL=index.9fc46c20.js.map
